unit View.Rt_Ibs_Cbs_Cst.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, WEBLib.Lists, WEBLib.Grids, Grid.Plugins, System.StrUtils,
  UConstantes, UUtils, UWeb.Enum;

type
  TFViewRt_Ibs_Cbs_CstEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbcst: TLabel;
    edcst: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientRt_Ibs_Cbs_CstGet: TXDataWebClient;
    Rt_Ibs_Cbs_CstDataset: TXDataWebDataSet;
    Rt_Ibs_Cbs_CstDatasetid: TIntegerField;
    Rt_Ibs_Cbs_CstDatasetcst: TStringField;
    Rt_Ibs_Cbs_CstDatasetdescricao: TStringField;
    Rt_Ibs_Cbs_CstDatasetexcluido: TBooleanField;
    Rt_Ibs_Cbs_CstDatasetinclusao: TDateTimeField;
    Rt_Ibs_Cbs_CstDatasetalteracao: TDateTimeField;
    Rt_Ibs_Cbs_CstDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    pnlEspacoFormRt_Ibs_Cbs_Cst: TPanel;
    btnRt_Ibs_Cbs_Cst: TButton;
    lbTotalIbsCbsClassTributaria: TLabel;
    btnIbsCbsClassTributaria: TButton;
    pnlIbsCbsClassTributaria: TPanel;
    cbPageSizeIbsCbsClassTributaria: TComboBox;
    IbsCbsClassTributariaSearch: TEdit;
    tblIbsCbsClassTributaria: TDBTableControl;
    wlcIbsCbsClassTributaria: TListControl;
    dtsIbsCbsClassTributaria: TDataSource;
    cdsIbsCbsClassTributaria: TXDataWebDataSet;
    tmrConsultaIbsCbsClassTributaria: TTimer;
    cdsIbsCbsClassTributariaid: TIntegerField;
    cdsIbsCbsClassTributariart_ibs_cbs_cst_id: TIntegerField;
    cdsIbsCbsClassTributariacclasstrib: TStringField;
    cdsIbsCbsClassTributariadata_inicio: TDateTimeField;
    cdsIbsCbsClassTributariadata_fim: TDateTimeField;
    cdsIbsCbsClassTributariaexcluido: TBooleanField;
    cdsIbsCbsClassTributariainclusao: TDateTimeField;
    cdsIbsCbsClassTributariaalteracao: TDateTimeField;
    cdsIbsCbsClassTributariaexclusao: TDateTimeField;
    cdsIbsCbsClassTributariaEdit: TXDataWebDataSet;
    IntegerField1: TIntegerField;
    IntegerField2: TIntegerField;
    StringField1: TStringField;
    StringField2: TStringField;
    StringField3: TStringField;
    StringField4: TStringField;
    DateTimeField1: TDateTimeField;
    DateTimeField2: TDateTimeField;
    BooleanField1: TBooleanField;
    DateTimeField3: TDateTimeField;
    DateTimeField4: TDateTimeField;
    DateTimeField5: TDateTimeField;
    pnlEspacoFormIbsCbsClassTributaria: TPanel;
    lbid_classtrib: TLabel;
    edid_classtrib: TDBEdit;
    lbrt_ibs_cbs_cst_id: TLabel;
    lbcclasstrib: TLabel;
    edcclasstrib: TDBEdit;
    lbdescricao_classtrib: TLabel;
    eddescricao_classtrib: TDBEdit;
    lblei_complementar: TLabel;
    edlei_complementar: TDBEdit;
    lblei_complementar_redacao: TLabel;
    edlei_complementar_redacao: TDBEdit;
    lbdata_inicio: TLabel;
    lbdata_fim: TLabel;
    lbexcluido_classtrib: TLabel;
    lbinclusao_classtrib: TLabel;
    edinclusao_classtrib: TDBEdit;
    lbalteracao_classtrib: TLabel;
    edalteracao_classtrib: TDBEdit;
    lbexclusao_classtrib: TLabel;
    ed_exclusao: TDBEdit;
    cbExcluidoClassTrib: TDBCheckBox;
    dtsIbsCbsClassTributariaEdit: TDataSource;
    cdsIbsCbsCst: TXDataWebDataSet;
    cbbIbsCbsCstId: TComboBox;
    cdsIbsCbsCstid: TIntegerField;
    cdsIbsCbsCstdescricao: TStringField;
    btnNovo: TButton;
    eddata_inicio: TDBDateTimePicker;
    eddata_fim: TDBDateTimePicker;
    btnSalvarClassTrib: TButton;
    cdsIbsCbsCstcst: TStringField;
    lbind_gIBSCBS: TLabel;
    edind_gIBSCBS: TDBEdit;
    lbind_gIBSCBSMono: TLabel;
    edind_gIBSCBSMono: TDBEdit;
    lbind_gRed: TLabel;
    edind_gRed: TDBEdit;
    lbind_gDif: TLabel;
    edind_gDif: TDBEdit;
    lbind_gTransfCred: TLabel;
    edind_gTransfCred: TDBEdit;
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBS: TStringField;
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono: TStringField;
    Rt_Ibs_Cbs_CstDatasetind_gRed: TStringField;
    Rt_Ibs_Cbs_CstDatasetind_gDif: TStringField;
    Rt_Ibs_Cbs_CstDatasetind_gTransfCred: TStringField;
    lbind_gCredPresIBSZFM: TLabel;
    cbind_gCredPresIBSZFM: TDBCheckBox;
    lbind_gAjusteCompet: TLabel;
    cbind_gAjusteCompet: TDBCheckBox;
    cdsIbsCbsClassTributarianome_cClassTrib: TStringField;
    lbnome_cClassTrib: TLabel;
    ednome_cClassTrib: TDBEdit;
    cdsIbsCbsClassTributariaEditnome_cClassTrib: TStringField;
    cdsIbsCbsClassTributariaEdittipo_aliquota: TStringField;
    cdsIbsCbsClassTributariaEditpRedIBS: TStringField;
    cdsIbsCbsClassTributariaEditpRedCBS: TStringField;
    cdsIbsCbsClassTributariaEditind_gTribRegular: TStringField;
    cdsIbsCbsClassTributariaEditdata_atualizacao: TDateField;
    lbpRedCBS: TLabel;
    edpRedCBS: TDBEdit;
    edind_gTribRegular: TDBEdit;
    lbind_gTribRegular: TLabel;
    edtipo_aliquota: TDBEdit;
    lbtipo_aliquota: TLabel;
    lbpRedIBS: TLabel;
    edpRedIBS: TDBEdit;
    eddata_atualizacao: TDBDateTimePicker;
    lbdata_atualizacao: TLabel;
    Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM: TBooleanField;
    Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet: TBooleanField;
    lbindNFe: TLabel;
    cbindNFe: TDBCheckBox;
    lbindNFCe: TLabel;
    cbindNFCe: TDBCheckBox;
    lbindNFSe: TLabel;
    cbindNFSe: TDBCheckBox;
    lbind_gEstornoCred: TLabel;
    cbind_gEstornoCred: TDBCheckBox;
    lbind_gCredPresOper: TLabel;
    cbind_gCredPresOper: TDBCheckBox;
    lbind_gMonoPadrao: TLabel;
    cbind_gMonoPadrao: TDBCheckBox;
    lbind_gMonoReten: TLabel;
    cbind_gMonoReten: TDBCheckBox;
    lbind_gMonoRet: TLabel;
    cbind_gMonoRet: TDBCheckBox;
    lbind_gpBioDiferenca: TLabel;
    cbind_gpBioDiferenca: TDBCheckBox;
    cdsIbsCbsClassTributariaEditindNFe: TBooleanField;
    cdsIbsCbsClassTributariaEditindNFCe: TBooleanField;
    cdsIbsCbsClassTributariaEditindNFSe: TBooleanField;
    cdsIbsCbsClassTributariaEditind_gEstornoCred: TBooleanField;
    cdsIbsCbsClassTributariaEditind_gCredPresOper: TBooleanField;
    cdsIbsCbsClassTributariaEditind_gMonoPadrao: TBooleanField;
    cdsIbsCbsClassTributariaEditind_gMonoReten: TBooleanField;
    cdsIbsCbsClassTributariaEditind_gMonoRet: TBooleanField;
    cbind_RedutorBC: TDBCheckBox;
    Rt_Ibs_Cbs_CstDatasetind_RedutorBC: TBooleanField;
    cdsIbsCbsClassTributariaEditind_gpBioDiferenca: TBooleanField;
    cdsIbsCbsClassTributariaEdittpRBSN: TIntegerField;
    lbtpRBSN: TLabel;
    edtpRBSN: TDBEdit;
    lbtpDoacao: TLabel;
    edtpDoacao: TDBEdit;
    cdsIbsCbsClassTributariaEdittpDoacao: TIntegerField;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientRt_Ibs_Cbs_CstGetLoad(Response: TXDataClientResponse);
    procedure Rt_Ibs_Cbs_CstDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure edcstKeyPress(Sender: TObject; var Key: Char);
    procedure edcstClick(Sender: TObject);
    procedure eddescricaoClick(Sender: TObject);
    procedure btnIbsCbsClassTributariaClick(Sender: TObject);
    procedure tblIbsCbsClassTributariaGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure tblIbsCbsClassTributariaGetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblIbsCbsClassTributariaGetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure cdsIbsCbsClassTributariaEditAfterOpen(DataSet: TDataSet);
    procedure IbsCbsClassTributariaSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure IbsCbsClassTributariaSearchKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cbPageSizeIbsCbsClassTributariaChange(Sender: TObject);
    procedure tmrConsultaIbsCbsClassTributariaTimer(Sender: TObject);
    procedure cdsIbsCbsCstAfterOpen(DataSet: TDataSet);
    procedure btnNovoClick(Sender: TObject);
    procedure edcclasstribKeyPress(Sender: TObject; var Key: Char);
    procedure cdsIbsCbsClassTributariaEditAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    [async]
    procedure btnSalvarClassTribClick(Sender: TObject); async;
    procedure cbbIbsCbsCstIdClick(Sender: TObject);
    procedure edcclasstribClick(Sender: TObject);
    procedure eddescricao_classtribClick(Sender: TObject);
    procedure eddata_fimClick(Sender: TObject);
    procedure Rt_Ibs_Cbs_CstDatasetAfterOpen(DataSet: TDataSet);
    procedure edtpRBSNKeyPress(Sender: TObject; var Key: Char);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginIbsCbsClassTributaria : TGridPlugin;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    function ValidarCampos(pRtIbsCbsCst : Boolean = True) : TArray<string>;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewRt_Ibs_Cbs_CstEdit: TFViewRt_Ibs_Cbs_CstEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRt_Ibs_Cbs_CstEdit }

procedure TFViewRt_Ibs_Cbs_CstEdit.btnIbsCbsClassTributariaClick(Sender: TObject);
begin
  if not Assigned(FGridPluginIbsCbsClassTributaria) then
  begin
    FGridPluginIbsCbsClassTributaria := TGridPlugin.Create(tblIbsCbsClassTributaria,
      cdsIbsCbsClassTributaria, wlcIbsCbsClassTributaria, lbTotalIbsCbsClassTributaria);
    FGridPluginIbsCbsClassTributaria.FDatasetPlugin.FOrderByPadrao := 'id desc';
    FGridPluginIbsCbsClassTributaria.FDatasetPlugin.FFilterPadrao := 'rt_ibs_cbs_cst_id eq ' + edid.Text;
    FGridPluginIbsCbsClassTributaria.SetPageSize(StrToInt(cbPageSizeIbsCbsClassTributaria.Text));
    FGridPluginIbsCbsClassTributaria.SetFilterText(IbsCbsClassTributariaSearch.Text);
  end;

  FGridPluginIbsCbsClassTributaria.Load;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.btnNovoClick(Sender: TObject);
begin
  TUtils.DesbloquearCamposDiv('camposFormClassTrib');
  btnSalvarClassTrib.Enabled := True; 
  THelperServer.ElementoHide('div_campos_visualizar_class_trib');

  cdsIbsCbsClassTributariaEdit.Close;
  cdsIbsCbsClassTributariaEdit.SetJsonData('{}');
  cdsIbsCbsClassTributariaEdit.Open;
  cdsIbsCbsClassTributariaEdit.Insert;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.btnSalvarClassTribClick(Sender: TObject);
var
  lErro : TArray<string>;
  lInserir : Boolean;
begin
  lErro := ValidarCampos(False);
  lInserir := Trim(edid_classtrib.Text) = '';

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemBotaoSalvar(lInserir,
    'Classificação Tributária'))) then
  begin
    TUtils.ChamarDivLoading;

    if cdsIbsCbsClassTributariaEdit.State in dsEditModes then
    begin
      cdsIbsCbsClassTributariaEdit.FieldByName('rt_ibs_cbs_cst_id').AsInteger := THelperServer.GetIdCombo(cdsIbsCbsCst,
        cbbIbsCbsCstId.ItemIndex);

      cdsIbsCbsClassTributariaEdit.Post;
      cdsIbsCbsClassTributariaEdit.ApplyUpdates;
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.btSaveClick(Sender: TObject);
var
  lErro : TArray<string>;
begin
  lErro := ValidarCampos;

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemBotaoSalvar(FInserting,
    'IBS CBS CST'))) then
  begin
    TUtils.ChamarDivLoading;

    if Rt_Ibs_Cbs_CstDataset.State in dsEditModes then
    begin
      Rt_Ibs_Cbs_CstDataset.Post;
      Rt_Ibs_Cbs_CstDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.cbbIbsCbsCstIdClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_ibs_cbs_class_tributaria_form_lbrt_ibs_cbs_cst_id');
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.cbPageSizeIbsCbsClassTributariaChange(
  Sender: TObject);
begin
  FGridPluginIbsCbsClassTributaria.SetPageSize(StrToInt(cbPageSizeIbsCbsClassTributaria.Text), True);
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.cdsIbsCbsClassTributariaEditAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);

      Exit;
    end;
  end;

  TUtils.CloseModal('modal_ibs_cbs_class_tributaria');
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FGridPluginIbsCbsClassTributaria.Load;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.cdsIbsCbsClassTributariaEditAfterOpen(
  DataSet: TDataSet);
begin
  THelperServer.SetIndexCombo(cdsIbsCbsCst, StrToInt(edid.Text), cbbIbsCbsCstId);

  if Trim(edid_classtrib.Text) <> '' then
    THelperServer.ElementoShow('div_campos_visualizar_class_trib');

  TUtils.OpenModal('modal_ibs_cbs_class_tributaria');
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.cdsIbsCbsCstAfterOpen(DataSet: TDataSet);
begin
  THelperServer.ConverterCdsEmCombo(cdsIbsCbsCst, cbbIbsCbsCstId);
end;

class function TFViewRt_Ibs_Cbs_CstEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.edcclasstribClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_ibs_cbs_class_tributaria_form_lbcclasstrib');
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.edcclasstribKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.edcstClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_ibs_cbs_cst_form_lbcst');
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.edcstKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.eddata_fimClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_ibs_cbs_class_tributaria_form_lbdata_fim');
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.eddescricaoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_ibs_cbs_cst_form_lbdescricao');
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.eddescricao_classtribClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_ibs_cbs_class_tributaria_form_lbdescricao');
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.edtpRBSNKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9', '.']) Then
    key := #0;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.IbsCbsClassTributariaSearchKeyDown(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsultaIbsCbsClassTributaria.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginIbsCbsClassTributaria.SetFilterText(IbsCbsClassTributariaSearch.Text, True);
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.IbsCbsClassTributariaSearchKeyUp(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsultaIbsCbsClassTributaria.Interval := FTimerConsulta;
  tmrConsultaIbsCbsClassTributaria.Enabled := True;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.InsertEntity;
begin
  Rt_Ibs_Cbs_CstDataset.Close;
  Rt_Ibs_Cbs_CstDataset.SetJsonData('{}');
  Rt_Ibs_Cbs_CstDataset.Open;
  Rt_Ibs_Cbs_CstDataset.Insert;
end;

class function TFViewRt_Ibs_Cbs_CstEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRt_Ibs_Cbs_CstEdit(AForm).FInserting := AInserting;
    TFViewRt_Ibs_Cbs_CstEdit(AForm).FId := AId;
    TFViewRt_Ibs_Cbs_CstEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewRt_Ibs_Cbs_CstEdit(AForm).InsertEntity
    else
      TFViewRt_Ibs_Cbs_CstEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewRt_Ibs_Cbs_CstEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Rt_Ibs_Cbs_CstDataset.Connection.Model.DefaultSchema.FindEntityType(
      Rt_Ibs_Cbs_CstDataset.EntitySetName
    )
  );
  XDataClientRt_Ibs_Cbs_CstGet.Get(Rt_Ibs_Cbs_CstDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.ShowNotification(Notification: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Notification);
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.tblIbsCbsClassTributariaGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordCdsCurrent: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    cdsIbsCbsClassTributariaEdit.Close;
    cdsIbsCbsClassTributariaEdit.SetJsonData(RecordCdsCurrent);
    cdsIbsCbsClassTributariaEdit.Open;
    cdsIbsCbsClassTributariaEdit.Edit;

    if not TUtils.PossuiPermissao(cdsIbsCbsClassTributaria.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      TUtils.BloquearCamposDiv('camposFormClassTrib');
      btnSalvarClassTrib.Enabled := False; 
    end;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblIbsCbsClassTributaria.Columns[ACol].Title = 'Ação' then
  begin
    RecordCdsCurrent := cdsIbsCbsClassTributaria.CurrentData;

    Button := TButton.Create(nil);

    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_ibs_cbs_class_tributaria');
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.tblIbsCbsClassTributariaGetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblIbsCbsClassTributaria.Columns[ACol].DataField, ['nome_cClassTrib']) of
      0: AClassName := 'text-left';
    else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.tblIbsCbsClassTributariaGetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblIbsCbsClassTributaria.Columns[ACol].DataField, ['excluido', 'nome_cClassTrib']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        if Length(AValue) > 100 then
          AValue := Copy(AValue, 1, 100) + '...';
      end;
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.tmrConsultaIbsCbsClassTributariaTimer(
  Sender: TObject);
begin
  FGridPluginIbsCbsClassTributaria.SetFilterText(IbsCbsClassTributariaSearch.Text, True);

  tmrConsultaIbsCbsClassTributaria.Enabled := False;
  tmrConsultaIbsCbsClassTributaria.Interval := FTimerConsulta;
end;

function TFViewRt_Ibs_Cbs_CstEdit.ValidarCampos(
  pRtIbsCbsCst: Boolean): TArray<string>;
begin
  TUtils.LimparErrosClass;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := 'view_rt_ibs_cbs_cst_form_lbcst';

  if pRtIbsCbsCst then
  begin
    if Trim(edcst.Text) = '' then
    begin
      Result[0] := 'CST não pode ser vazio!';
      Result[1] := 'view_rt_ibs_cbs_cst_form_lbcst';
      Exit;
    end;

    if Trim(eddescricao.Text) = '' then
    begin
      Result[0] := 'Descrição não pode ser vazia!';
      Result[1] := 'view_rt_ibs_cbs_cst_form_lbdescricao';
      Exit;
    end;
  end
  else
  begin
    if Trim(cbbIbsCbsCstId.Text) = '' then
    begin
      Result[0] := 'Selecione o IBS CBS CST!';
      Result[1] := 'view_rt_ibs_cbs_class_tributaria_form_lbrt_ibs_cbs_cst_id';
      Exit;
    end;

    if Trim(edcclasstrib.Text) = '' then
    begin
      Result[0] := 'CCLASSTRIB não pode ser vazio!';
      Result[1] := 'view_rt_ibs_cbs_class_tributaria_form_lbcclasstrib';
      Exit;
    end;

    if (DateToStr(eddata_inicio.Date) <> '30/12/1899') and
      (DateToStr(eddata_fim.Date) <> '30/12/1899') then
    begin
      if eddata_inicio.Date > eddata_fim.Date then
      begin
        Result[0] := 'Data final não pode ser menor que a inicial!';
        Result[1] := 'view_rt_ibs_cbs_class_tributaria_form_lbdata_fim';
        Exit;
      end;
    end;

    if Trim(eddescricao_classtrib.Text) = '' then
    begin
      Result[0] := 'Descrição não pode ser vazia!';
      Result[1] := 'view_rt_ibs_cbs_class_tributaria_form_lbdescricao';
      Exit;
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.WebFormShow(Sender: TObject);
begin
  if FInserting or not TUtils.PossuiPermissao(cdsIbsCbsClassTributaria.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId(btnIbsCbsClassTributaria.ElementID);
    THelperServer.RemoverElementoPorId('line-rt_ibs_cbs_class_tributaria');
    THelperServer.RemoverElementoPorId('modal_ibs_cbs_class_tributaria');
  end;

  if FInserting then
  begin
    THelperServer.RemoverElementoPorId('div_campos_visualizar');

    if edcst.CanFocus then
      edcst.SetFocus;
  end
  else
  begin
    if TUtils.PossuiPermissao(cdsIbsCbsClassTributaria.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
      cdsIbsCbsCst.Load;

    btnNovo.Enabled := TUtils.PossuiPermissao(cdsIbsCbsClassTributaria.EntitySetName.ToLower, TTipoPermissao.INSERIR);
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.XDataClientRt_Ibs_Cbs_CstGetLoad(Response: TXDataClientResponse);
begin
  Rt_Ibs_Cbs_CstDataset.Close;
  Rt_Ibs_Cbs_CstDataset.SetJsonData(Response.Result);
  Rt_Ibs_Cbs_CstDataset.Open;
  
  Rt_Ibs_Cbs_CstDataset.Edit;  
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.Rt_Ibs_Cbs_CstDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);

      Rt_Ibs_Cbs_CstDataset.Edit;

      Exit;
    end;
  end;


  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FShowListProc;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.Rt_Ibs_Cbs_CstDatasetAfterOpen(
  DataSet: TDataSet);
begin
  if not TUtils.PossuiPermissao(Rt_Ibs_Cbs_CstDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
  begin
    btSave.Enabled := False;

    asm
      window.setTimeout(function() {
        pas.UUtils.TUtils.BloquearCamposDiv('camposFormRtIbsCbsCst');
      }, 200);
    end;
  end;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewRt_Ibs_Cbs_CstEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.rt_ibs_cbs_cst.form.lbid');
  lbcst := TLabel.Create('view.rt_ibs_cbs_cst.form.lbcst');
  lbdescricao := TLabel.Create('view.rt_ibs_cbs_cst.form.lbdescricao');
  lbexcluido := TLabel.Create('view.rt_ibs_cbs_cst.form.lbexcluido');
  lbinclusao := TLabel.Create('view.rt_ibs_cbs_cst.form.lbinclusao');
  lbalteracao := TLabel.Create('view.rt_ibs_cbs_cst.form.lbalteracao');
  lbexclusao := TLabel.Create('view.rt_ibs_cbs_cst.form.lbexclusao');
  lbTotalIbsCbsClassTributaria := TLabel.Create('lbTotalIbsCbsClassTributaria');
  lbid_classtrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbid');
  lbrt_ibs_cbs_cst_id := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbrt_ibs_cbs_cst_id');
  lbcclasstrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbcclasstrib');
  lbdescricao_classtrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbdescricao');
  lblei_complementar := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lblei_complementar');
  lblei_complementar_redacao := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lblei_complementar_redacao');
  lbdata_inicio := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbdata_inicio');
  lbdata_fim := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbdata_fim');
  lbexcluido_classtrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbexcluido');
  lbinclusao_classtrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbinclusao');
  lbalteracao_classtrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbalteracao');
  lbexclusao_classtrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbexclusao');
  lbind_gIBSCBS := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gIBSCBS');
  lbind_gIBSCBSMono := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gIBSCBSMono');
  lbind_gRed := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gRed');
  lbind_gDif := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gDif');
  lbind_gTransfCred := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gTransfCred');
  lbind_gCredPresIBSZFM := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gCredPresIBSZFM');
  lbind_gAjusteCompet := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gAjusteCompet');
  lbnome_cClassTrib := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbnome_cClassTrib');
  lbpRedCBS := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbpRedCBS');
  lbind_gTribRegular := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbind_gTribRegular');
  lbtipo_aliquota := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbtipo_aliquota');
  lbpRedIBS := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbpRedIBS');
  lbdata_atualizacao := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbdata_atualizacao');
  lbindNFe := TLabel.Create('view.rt_ibs_cbs_cst.form.lbindNFe');
  lbindNFCe := TLabel.Create('view.rt_ibs_cbs_cst.form.lbindNFCe');
  lbindNFSe := TLabel.Create('view.rt_ibs_cbs_cst.form.lbindNFSe');
  lbind_gEstornoCred := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gEstornoCred');
  lbind_gCredPresOper := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gCredPresOper');
  lbind_gMonoPadrao := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gMonoPadrao');
  lbind_gMonoReten := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gMonoReten');
  lbind_gMonoRet := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gMonoRet');
  lbind_gpBioDiferenca := TLabel.Create('view.rt_ibs_cbs_cst.form.lbind_gpBioDiferenca');
  lbtpRBSN := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbtpRBSN');
  lbtpDoacao := TLabel.Create('view.rt_ibs_cbs_class_tributaria.form.lbtpDoacao');
  btCancel := TButton.Create('view.rt_ibs_cbs_cst.form.btBack');
  btSave := TButton.Create('view.rt_ibs_cbs_cst.form.btSave');
  edid := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edid');
  edcst := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edcst');
  eddescricao := TDBEdit.Create('view.rt_ibs_cbs_cst.form.eddescricao');
  edinclusao := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edinclusao');
  edalteracao := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edalteracao');
  edexclusao := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbexcluido');
  pnlEspacoFormRt_Ibs_Cbs_Cst := TPanel.Create(Self);
  btnRt_Ibs_Cbs_Cst := TButton.Create('line-rt_ibs_cbs_cst-tab');
  btnIbsCbsClassTributaria := TButton.Create('line-rt_ibs_cbs_class_tributaria-tab');
  pnlIbsCbsClassTributaria := TPanel.Create(Self);
  cbPageSizeIbsCbsClassTributaria := TComboBox.Create('cbPageSizeIbsCbsClassTributaria');
  IbsCbsClassTributariaSearch := TEdit.Create('IbsCbsClassTributariaSearch');
  tblIbsCbsClassTributaria := TDBTableControl.Create('tblIbsCbsClassTributaria');
  wlcIbsCbsClassTributaria := TListControl.Create('wlcIbsCbsClassTributaria');
  pnlEspacoFormIbsCbsClassTributaria := TPanel.Create(Self);
  edid_classtrib := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edid');
  edcclasstrib := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edcclasstrib');
  eddescricao_classtrib := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.eddescricao');
  edlei_complementar := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edlei_complementar');
  edlei_complementar_redacao := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edlei_complementar_redacao');
  edinclusao_classtrib := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edinclusao');
  edalteracao_classtrib := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edalteracao');
  ed_exclusao := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edexclusao');
  cbExcluidoClassTrib := TDBCheckBox.Create('view.rt_ibs_cbs_class_tributaria.form.cbexcluido');
  cbbIbsCbsCstId := TComboBox.Create('view.rt_ibs_cbs_class_tributaria.form.cbrt_ibs_cbs_cst_id');
  btnNovo := TButton.Create('view.rt_ibs_cbs_cst.edit.newbutton');
  eddata_inicio := TDBDateTimePicker.Create('view.rt_ibs_cbs_class_tributaria.form.eddata_inicio');
  eddata_fim := TDBDateTimePicker.Create('view.rt_ibs_cbs_class_tributaria.form.eddata_fim');
  btnSalvarClassTrib := TButton.Create('view.rt_ibs_cbs_class_tributaria.form.btSave');
  edind_gIBSCBS := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edind_gIBSCBS');
  edind_gIBSCBSMono := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edind_gIBSCBSMono');
  edind_gRed := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edind_gRed');
  edind_gDif := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edind_gDif');
  edind_gTransfCred := TDBEdit.Create('view.rt_ibs_cbs_cst.form.edind_gTransfCred');
  cbind_gCredPresIBSZFM := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gCredPresIBSZFM');
  cbind_gAjusteCompet := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gAjusteCompet');
  ednome_cClassTrib := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.ednome_cClassTrib');
  edpRedCBS := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edpRedCBS');
  edind_gTribRegular := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edind_gTribRegular');
  edtipo_aliquota := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edtipo_aliquota');
  edpRedIBS := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edpRedIBS');
  eddata_atualizacao := TDBDateTimePicker.Create('view.rt_ibs_cbs_class_tributaria.form.eddata_atualizacao');
  cbindNFe := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbindNFe');
  cbindNFCe := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbindNFCe');
  cbindNFSe := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbindNFSe');
  cbind_gEstornoCred := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gEstornoCred');
  cbind_gCredPresOper := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gCredPresOper');
  cbind_gMonoPadrao := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gMonoPadrao');
  cbind_gMonoReten := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gMonoReten');
  cbind_gMonoRet := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gMonoRet');
  cbind_gpBioDiferenca := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_gpBioDiferenca');
  cbind_RedutorBC := TDBCheckBox.Create('view.rt_ibs_cbs_cst.form.cbind_RedutorBC');
  edtpRBSN := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edtpRBSN');
  edtpDoacao := TDBEdit.Create('view.rt_ibs_cbs_class_tributaria.form.edtpDoacao');
  DataSource := TDataSource.Create(Self);
  Rt_Ibs_Cbs_CstDataset := TXDataWebDataSet.Create(Self);
  Rt_Ibs_Cbs_CstDatasetid := TIntegerField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetcst := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetdescricao := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetexcluido := TBooleanField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetinclusao := TDateTimeField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetalteracao := TDateTimeField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetexclusao := TDateTimeField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_gIBSCBS := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_gRed := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_gDif := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_gTransfCred := TStringField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM := TBooleanField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet := TBooleanField.Create(Self);
  Rt_Ibs_Cbs_CstDatasetind_RedutorBC := TBooleanField.Create(Self);
  XDataClientRt_Ibs_Cbs_CstGet := TXDataWebClient.Create(Self);
  dtsIbsCbsClassTributaria := TDataSource.Create(Self);
  cdsIbsCbsClassTributaria := TXDataWebDataSet.Create(Self);
  cdsIbsCbsClassTributariaid := TIntegerField.Create(Self);
  cdsIbsCbsClassTributariart_ibs_cbs_cst_id := TIntegerField.Create(Self);
  cdsIbsCbsClassTributariacclasstrib := TStringField.Create(Self);
  cdsIbsCbsClassTributariadata_inicio := TDateTimeField.Create(Self);
  cdsIbsCbsClassTributariadata_fim := TDateTimeField.Create(Self);
  cdsIbsCbsClassTributariaexcluido := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariainclusao := TDateTimeField.Create(Self);
  cdsIbsCbsClassTributariaalteracao := TDateTimeField.Create(Self);
  cdsIbsCbsClassTributariaexclusao := TDateTimeField.Create(Self);
  cdsIbsCbsClassTributarianome_cClassTrib := TStringField.Create(Self);
  tmrConsultaIbsCbsClassTributaria := TTimer.Create(Self);
  cdsIbsCbsClassTributariaEdit := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  IntegerField2 := TIntegerField.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  StringField3 := TStringField.Create(Self);
  StringField4 := TStringField.Create(Self);
  DateTimeField1 := TDateTimeField.Create(Self);
  DateTimeField2 := TDateTimeField.Create(Self);
  BooleanField1 := TBooleanField.Create(Self);
  DateTimeField3 := TDateTimeField.Create(Self);
  DateTimeField4 := TDateTimeField.Create(Self);
  DateTimeField5 := TDateTimeField.Create(Self);
  cdsIbsCbsClassTributariaEditnome_cClassTrib := TStringField.Create(Self);
  cdsIbsCbsClassTributariaEdittipo_aliquota := TStringField.Create(Self);
  cdsIbsCbsClassTributariaEditpRedIBS := TStringField.Create(Self);
  cdsIbsCbsClassTributariaEditpRedCBS := TStringField.Create(Self);
  cdsIbsCbsClassTributariaEditind_gTribRegular := TStringField.Create(Self);
  cdsIbsCbsClassTributariaEditdata_atualizacao := TDateField.Create(Self);
  cdsIbsCbsClassTributariaEditindNFe := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditindNFCe := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditindNFSe := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditind_gEstornoCred := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditind_gCredPresOper := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditind_gMonoPadrao := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditind_gMonoReten := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditind_gMonoRet := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEditind_gpBioDiferenca := TBooleanField.Create(Self);
  cdsIbsCbsClassTributariaEdittpRBSN := TIntegerField.Create(Self);
  cdsIbsCbsClassTributariaEdittpDoacao := TIntegerField.Create(Self);
  dtsIbsCbsClassTributariaEdit := TDataSource.Create(Self);
  cdsIbsCbsCst := TXDataWebDataSet.Create(Self);
  cdsIbsCbsCstid := TIntegerField.Create(Self);
  cdsIbsCbsCstdescricao := TStringField.Create(Self);
  cdsIbsCbsCstcst := TStringField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbcst.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbTotalIbsCbsClassTributaria.BeforeLoadDFMValues;
  lbid_classtrib.BeforeLoadDFMValues;
  lbrt_ibs_cbs_cst_id.BeforeLoadDFMValues;
  lbcclasstrib.BeforeLoadDFMValues;
  lbdescricao_classtrib.BeforeLoadDFMValues;
  lblei_complementar.BeforeLoadDFMValues;
  lblei_complementar_redacao.BeforeLoadDFMValues;
  lbdata_inicio.BeforeLoadDFMValues;
  lbdata_fim.BeforeLoadDFMValues;
  lbexcluido_classtrib.BeforeLoadDFMValues;
  lbinclusao_classtrib.BeforeLoadDFMValues;
  lbalteracao_classtrib.BeforeLoadDFMValues;
  lbexclusao_classtrib.BeforeLoadDFMValues;
  lbind_gIBSCBS.BeforeLoadDFMValues;
  lbind_gIBSCBSMono.BeforeLoadDFMValues;
  lbind_gRed.BeforeLoadDFMValues;
  lbind_gDif.BeforeLoadDFMValues;
  lbind_gTransfCred.BeforeLoadDFMValues;
  lbind_gCredPresIBSZFM.BeforeLoadDFMValues;
  lbind_gAjusteCompet.BeforeLoadDFMValues;
  lbnome_cClassTrib.BeforeLoadDFMValues;
  lbpRedCBS.BeforeLoadDFMValues;
  lbind_gTribRegular.BeforeLoadDFMValues;
  lbtipo_aliquota.BeforeLoadDFMValues;
  lbpRedIBS.BeforeLoadDFMValues;
  lbdata_atualizacao.BeforeLoadDFMValues;
  lbindNFe.BeforeLoadDFMValues;
  lbindNFCe.BeforeLoadDFMValues;
  lbindNFSe.BeforeLoadDFMValues;
  lbind_gEstornoCred.BeforeLoadDFMValues;
  lbind_gCredPresOper.BeforeLoadDFMValues;
  lbind_gMonoPadrao.BeforeLoadDFMValues;
  lbind_gMonoReten.BeforeLoadDFMValues;
  lbind_gMonoRet.BeforeLoadDFMValues;
  lbind_gpBioDiferenca.BeforeLoadDFMValues;
  lbtpRBSN.BeforeLoadDFMValues;
  lbtpDoacao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edcst.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  pnlEspacoFormRt_Ibs_Cbs_Cst.BeforeLoadDFMValues;
  btnRt_Ibs_Cbs_Cst.BeforeLoadDFMValues;
  btnIbsCbsClassTributaria.BeforeLoadDFMValues;
  pnlIbsCbsClassTributaria.BeforeLoadDFMValues;
  cbPageSizeIbsCbsClassTributaria.BeforeLoadDFMValues;
  IbsCbsClassTributariaSearch.BeforeLoadDFMValues;
  tblIbsCbsClassTributaria.BeforeLoadDFMValues;
  wlcIbsCbsClassTributaria.BeforeLoadDFMValues;
  pnlEspacoFormIbsCbsClassTributaria.BeforeLoadDFMValues;
  edid_classtrib.BeforeLoadDFMValues;
  edcclasstrib.BeforeLoadDFMValues;
  eddescricao_classtrib.BeforeLoadDFMValues;
  edlei_complementar.BeforeLoadDFMValues;
  edlei_complementar_redacao.BeforeLoadDFMValues;
  edinclusao_classtrib.BeforeLoadDFMValues;
  edalteracao_classtrib.BeforeLoadDFMValues;
  ed_exclusao.BeforeLoadDFMValues;
  cbExcluidoClassTrib.BeforeLoadDFMValues;
  cbbIbsCbsCstId.BeforeLoadDFMValues;
  btnNovo.BeforeLoadDFMValues;
  eddata_inicio.BeforeLoadDFMValues;
  eddata_fim.BeforeLoadDFMValues;
  btnSalvarClassTrib.BeforeLoadDFMValues;
  edind_gIBSCBS.BeforeLoadDFMValues;
  edind_gIBSCBSMono.BeforeLoadDFMValues;
  edind_gRed.BeforeLoadDFMValues;
  edind_gDif.BeforeLoadDFMValues;
  edind_gTransfCred.BeforeLoadDFMValues;
  cbind_gCredPresIBSZFM.BeforeLoadDFMValues;
  cbind_gAjusteCompet.BeforeLoadDFMValues;
  ednome_cClassTrib.BeforeLoadDFMValues;
  edpRedCBS.BeforeLoadDFMValues;
  edind_gTribRegular.BeforeLoadDFMValues;
  edtipo_aliquota.BeforeLoadDFMValues;
  edpRedIBS.BeforeLoadDFMValues;
  eddata_atualizacao.BeforeLoadDFMValues;
  cbindNFe.BeforeLoadDFMValues;
  cbindNFCe.BeforeLoadDFMValues;
  cbindNFSe.BeforeLoadDFMValues;
  cbind_gEstornoCred.BeforeLoadDFMValues;
  cbind_gCredPresOper.BeforeLoadDFMValues;
  cbind_gMonoPadrao.BeforeLoadDFMValues;
  cbind_gMonoReten.BeforeLoadDFMValues;
  cbind_gMonoRet.BeforeLoadDFMValues;
  cbind_gpBioDiferenca.BeforeLoadDFMValues;
  cbind_RedutorBC.BeforeLoadDFMValues;
  edtpRBSN.BeforeLoadDFMValues;
  edtpDoacao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDataset.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetid.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetcst.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetdescricao.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetexcluido.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetinclusao.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetalteracao.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetexclusao.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_gIBSCBS.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_gRed.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_gDif.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_gTransfCred.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet.BeforeLoadDFMValues;
  Rt_Ibs_Cbs_CstDatasetind_RedutorBC.BeforeLoadDFMValues;
  XDataClientRt_Ibs_Cbs_CstGet.BeforeLoadDFMValues;
  dtsIbsCbsClassTributaria.BeforeLoadDFMValues;
  cdsIbsCbsClassTributaria.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaid.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariart_ibs_cbs_cst_id.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariacclasstrib.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariadata_inicio.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariadata_fim.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaexcluido.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariainclusao.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaalteracao.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaexclusao.BeforeLoadDFMValues;
  cdsIbsCbsClassTributarianome_cClassTrib.BeforeLoadDFMValues;
  tmrConsultaIbsCbsClassTributaria.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEdit.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  IntegerField2.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  StringField4.BeforeLoadDFMValues;
  DateTimeField1.BeforeLoadDFMValues;
  DateTimeField2.BeforeLoadDFMValues;
  BooleanField1.BeforeLoadDFMValues;
  DateTimeField3.BeforeLoadDFMValues;
  DateTimeField4.BeforeLoadDFMValues;
  DateTimeField5.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditnome_cClassTrib.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEdittipo_aliquota.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditpRedIBS.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditpRedCBS.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditind_gTribRegular.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditdata_atualizacao.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditindNFe.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditindNFCe.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditindNFSe.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditind_gEstornoCred.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditind_gCredPresOper.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditind_gMonoPadrao.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditind_gMonoReten.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditind_gMonoRet.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEditind_gpBioDiferenca.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEdittpRBSN.BeforeLoadDFMValues;
  cdsIbsCbsClassTributariaEdittpDoacao.BeforeLoadDFMValues;
  dtsIbsCbsClassTributariaEdit.BeforeLoadDFMValues;
  cdsIbsCbsCst.BeforeLoadDFMValues;
  cdsIbsCbsCstid.BeforeLoadDFMValues;
  cdsIbsCbsCstdescricao.BeforeLoadDFMValues;
  cdsIbsCbsCstcst.BeforeLoadDFMValues;
  try
    Name := 'FViewRt_Ibs_Cbs_CstEdit';
    Width := 800;
    Height := 665;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 32;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbcst.SetParentComponent(Self);
    lbcst.Name := 'lbcst';
    lbcst.Left := 8;
    lbcst.Top := 59;
    lbcst.Width := 23;
    lbcst.Height := 13;
    lbcst.Caption := 'CST:';
    lbcst.HeightPercent := 100.000000000000000000;
    lbcst.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 8;
    lbdescricao.Top := 86;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 8;
    lbexcluido.Top := 113;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 8;
    lbinclusao.Top := 140;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 8;
    lbalteracao.Top := 167;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 8;
    lbexclusao.Top := 194;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbTotalIbsCbsClassTributaria.SetParentComponent(Self);
    lbTotalIbsCbsClassTributaria.Name := 'lbTotalIbsCbsClassTributaria';
    lbTotalIbsCbsClassTributaria.Left := 456;
    lbTotalIbsCbsClassTributaria.Top := 218;
    lbTotalIbsCbsClassTributaria.Width := 141;
    lbTotalIbsCbsClassTributaria.Height := 13;
    lbTotalIbsCbsClassTributaria.Caption := 'Showing 1 to 10 of 57 entries';
    lbTotalIbsCbsClassTributaria.HeightPercent := 100.000000000000000000;
    lbTotalIbsCbsClassTributaria.WidthPercent := 100.000000000000000000;
    lbid_classtrib.SetParentComponent(Self);
    lbid_classtrib.Name := 'lbid_classtrib';
    lbid_classtrib.Left := 8;
    lbid_classtrib.Top := 336;
    lbid_classtrib.Width := 23;
    lbid_classtrib.Height := 13;
    lbid_classtrib.Caption := 'C'#243'd:';
    lbid_classtrib.HeightPercent := 100.000000000000000000;
    lbid_classtrib.WidthPercent := 100.000000000000000000;
    lbrt_ibs_cbs_cst_id.SetParentComponent(Self);
    lbrt_ibs_cbs_cst_id.Name := 'lbrt_ibs_cbs_cst_id';
    lbrt_ibs_cbs_cst_id.Left := 8;
    lbrt_ibs_cbs_cst_id.Top := 363;
    lbrt_ibs_cbs_cst_id.Width := 64;
    lbrt_ibs_cbs_cst_id.Height := 13;
    lbrt_ibs_cbs_cst_id.Caption := 'IBS CBS CST:';
    lbrt_ibs_cbs_cst_id.HeightPercent := 100.000000000000000000;
    lbrt_ibs_cbs_cst_id.WidthPercent := 100.000000000000000000;
    lbcclasstrib.SetParentComponent(Self);
    lbcclasstrib.Name := 'lbcclasstrib';
    lbcclasstrib.Left := 8;
    lbcclasstrib.Top := 390;
    lbcclasstrib.Width := 65;
    lbcclasstrib.Height := 13;
    lbcclasstrib.Caption := 'CCLASSTRIB:';
    lbcclasstrib.HeightPercent := 100.000000000000000000;
    lbcclasstrib.WidthPercent := 100.000000000000000000;
    lbdescricao_classtrib.SetParentComponent(Self);
    lbdescricao_classtrib.Name := 'lbdescricao_classtrib';
    lbdescricao_classtrib.Left := 8;
    lbdescricao_classtrib.Top := 417;
    lbdescricao_classtrib.Width := 50;
    lbdescricao_classtrib.Height := 13;
    lbdescricao_classtrib.Caption := 'Descri'#231#227'o:';
    lbdescricao_classtrib.HeightPercent := 100.000000000000000000;
    lbdescricao_classtrib.WidthPercent := 100.000000000000000000;
    lblei_complementar.SetParentComponent(Self);
    lblei_complementar.Name := 'lblei_complementar';
    lblei_complementar.Left := 8;
    lblei_complementar.Top := 444;
    lblei_complementar.Width := 89;
    lblei_complementar.Height := 13;
    lblei_complementar.Caption := 'Lei Complementar:';
    lblei_complementar.HeightPercent := 100.000000000000000000;
    lblei_complementar.WidthPercent := 100.000000000000000000;
    lblei_complementar_redacao.SetParentComponent(Self);
    lblei_complementar_redacao.Name := 'lblei_complementar_redacao';
    lblei_complementar_redacao.Left := 8;
    lblei_complementar_redacao.Top := 471;
    lblei_complementar_redacao.Width := 134;
    lblei_complementar_redacao.Height := 13;
    lblei_complementar_redacao.Caption := 'Lei Complementar Reda'#231#227'o:';
    lblei_complementar_redacao.HeightPercent := 100.000000000000000000;
    lblei_complementar_redacao.WidthPercent := 100.000000000000000000;
    lbdata_inicio.SetParentComponent(Self);
    lbdata_inicio.Name := 'lbdata_inicio';
    lbdata_inicio.Left := 264;
    lbdata_inicio.Top := 336;
    lbdata_inicio.Width := 55;
    lbdata_inicio.Height := 13;
    lbdata_inicio.Caption := 'Data In'#237'cio:';
    lbdata_inicio.HeightPercent := 100.000000000000000000;
    lbdata_inicio.WidthPercent := 100.000000000000000000;
    lbdata_fim.SetParentComponent(Self);
    lbdata_fim.Name := 'lbdata_fim';
    lbdata_fim.Left := 264;
    lbdata_fim.Top := 363;
    lbdata_fim.Width := 46;
    lbdata_fim.Height := 13;
    lbdata_fim.Caption := 'Data Fim:';
    lbdata_fim.HeightPercent := 100.000000000000000000;
    lbdata_fim.WidthPercent := 100.000000000000000000;
    lbexcluido_classtrib.SetParentComponent(Self);
    lbexcluido_classtrib.Name := 'lbexcluido_classtrib';
    lbexcluido_classtrib.Left := 264;
    lbexcluido_classtrib.Top := 390;
    lbexcluido_classtrib.Width := 43;
    lbexcluido_classtrib.Height := 13;
    lbexcluido_classtrib.Caption := 'Exclu'#237'do:';
    lbexcluido_classtrib.HeightPercent := 100.000000000000000000;
    lbexcluido_classtrib.WidthPercent := 100.000000000000000000;
    lbinclusao_classtrib.SetParentComponent(Self);
    lbinclusao_classtrib.Name := 'lbinclusao_classtrib';
    lbinclusao_classtrib.Left := 264;
    lbinclusao_classtrib.Top := 417;
    lbinclusao_classtrib.Width := 44;
    lbinclusao_classtrib.Height := 13;
    lbinclusao_classtrib.Caption := 'Inclus'#227'o:';
    lbinclusao_classtrib.HeightPercent := 100.000000000000000000;
    lbinclusao_classtrib.WidthPercent := 100.000000000000000000;
    lbalteracao_classtrib.SetParentComponent(Self);
    lbalteracao_classtrib.Name := 'lbalteracao_classtrib';
    lbalteracao_classtrib.Left := 264;
    lbalteracao_classtrib.Top := 444;
    lbalteracao_classtrib.Width := 50;
    lbalteracao_classtrib.Height := 13;
    lbalteracao_classtrib.Caption := 'Altera'#231#227'o:';
    lbalteracao_classtrib.HeightPercent := 100.000000000000000000;
    lbalteracao_classtrib.WidthPercent := 100.000000000000000000;
    lbexclusao_classtrib.SetParentComponent(Self);
    lbexclusao_classtrib.Name := 'lbexclusao_classtrib';
    lbexclusao_classtrib.Left := 264;
    lbexclusao_classtrib.Top := 471;
    lbexclusao_classtrib.Width := 46;
    lbexclusao_classtrib.Height := 13;
    lbexclusao_classtrib.Caption := 'Exclus'#227'o:';
    lbexclusao_classtrib.HeightPercent := 100.000000000000000000;
    lbexclusao_classtrib.WidthPercent := 100.000000000000000000;
    lbind_gIBSCBS.SetParentComponent(Self);
    lbind_gIBSCBS.Name := 'lbind_gIBSCBS';
    lbind_gIBSCBS.Left := 149;
    lbind_gIBSCBS.Top := 32;
    lbind_gIBSCBS.Width := 65;
    lbind_gIBSCBS.Height := 13;
    lbind_gIBSCBS.Caption := 'ind_gIBSCBS:';
    lbind_gIBSCBS.HeightPercent := 100.000000000000000000;
    lbind_gIBSCBS.WidthPercent := 100.000000000000000000;
    lbind_gIBSCBSMono.SetParentComponent(Self);
    lbind_gIBSCBSMono.Name := 'lbind_gIBSCBSMono';
    lbind_gIBSCBSMono.Left := 150;
    lbind_gIBSCBSMono.Top := 59;
    lbind_gIBSCBSMono.Width := 91;
    lbind_gIBSCBSMono.Height := 13;
    lbind_gIBSCBSMono.Caption := 'ind_gIBSCBSMono:';
    lbind_gIBSCBSMono.HeightPercent := 100.000000000000000000;
    lbind_gIBSCBSMono.WidthPercent := 100.000000000000000000;
    lbind_gRed.SetParentComponent(Self);
    lbind_gRed.Name := 'lbind_gRed';
    lbind_gRed.Left := 150;
    lbind_gRed.Top := 86;
    lbind_gRed.Width := 49;
    lbind_gRed.Height := 13;
    lbind_gRed.Caption := 'ind_gRed:';
    lbind_gRed.HeightPercent := 100.000000000000000000;
    lbind_gRed.WidthPercent := 100.000000000000000000;
    lbind_gDif.SetParentComponent(Self);
    lbind_gDif.Name := 'lbind_gDif';
    lbind_gDif.Left := 150;
    lbind_gDif.Top := 113;
    lbind_gDif.Width := 43;
    lbind_gDif.Height := 13;
    lbind_gDif.Caption := 'ind_gDif:';
    lbind_gDif.HeightPercent := 100.000000000000000000;
    lbind_gDif.WidthPercent := 100.000000000000000000;
    lbind_gTransfCred.SetParentComponent(Self);
    lbind_gTransfCred.Name := 'lbind_gTransfCred';
    lbind_gTransfCred.Left := 149;
    lbind_gTransfCred.Top := 140;
    lbind_gTransfCred.Width := 84;
    lbind_gTransfCred.Height := 13;
    lbind_gTransfCred.Caption := 'ind_gTransfCred:';
    lbind_gTransfCred.HeightPercent := 100.000000000000000000;
    lbind_gTransfCred.WidthPercent := 100.000000000000000000;
    lbind_gCredPresIBSZFM.SetParentComponent(Self);
    lbind_gCredPresIBSZFM.Name := 'lbind_gCredPresIBSZFM';
    lbind_gCredPresIBSZFM.Left := 149;
    lbind_gCredPresIBSZFM.Top := 168;
    lbind_gCredPresIBSZFM.Width := 111;
    lbind_gCredPresIBSZFM.Height := 13;
    lbind_gCredPresIBSZFM.Caption := 'ind_gCredPresIBSZFM?';
    lbind_gCredPresIBSZFM.HeightPercent := 100.000000000000000000;
    lbind_gCredPresIBSZFM.WidthPercent := 100.000000000000000000;
    lbind_gAjusteCompet.SetParentComponent(Self);
    lbind_gAjusteCompet.Name := 'lbind_gAjusteCompet';
    lbind_gAjusteCompet.Left := 149;
    lbind_gAjusteCompet.Top := 196;
    lbind_gAjusteCompet.Width := 99;
    lbind_gAjusteCompet.Height := 13;
    lbind_gAjusteCompet.Caption := 'ind_gAjusteCompet?';
    lbind_gAjusteCompet.HeightPercent := 100.000000000000000000;
    lbind_gAjusteCompet.WidthPercent := 100.000000000000000000;
    lbnome_cClassTrib.SetParentComponent(Self);
    lbnome_cClassTrib.Name := 'lbnome_cClassTrib';
    lbnome_cClassTrib.Left := 264;
    lbnome_cClassTrib.Top := 498;
    lbnome_cClassTrib.Width := 82;
    lbnome_cClassTrib.Height := 13;
    lbnome_cClassTrib.Caption := 'Nome cClassTrib:';
    lbnome_cClassTrib.HeightPercent := 100.000000000000000000;
    lbnome_cClassTrib.WidthPercent := 100.000000000000000000;
    lbpRedCBS.SetParentComponent(Self);
    lbpRedCBS.Name := 'lbpRedCBS';
    lbpRedCBS.Left := 487;
    lbpRedCBS.Top := 336;
    lbpRedCBS.Width := 48;
    lbpRedCBS.Height := 13;
    lbpRedCBS.Caption := 'pRedCBS:';
    lbpRedCBS.HeightPercent := 100.000000000000000000;
    lbpRedCBS.WidthPercent := 100.000000000000000000;
    lbind_gTribRegular.SetParentComponent(Self);
    lbind_gTribRegular.Name := 'lbind_gTribRegular';
    lbind_gTribRegular.Left := 487;
    lbind_gTribRegular.Top := 390;
    lbind_gTribRegular.Width := 85;
    lbind_gTribRegular.Height := 13;
    lbind_gTribRegular.Caption := 'ind_gTribRegular:';
    lbind_gTribRegular.HeightPercent := 100.000000000000000000;
    lbind_gTribRegular.WidthPercent := 100.000000000000000000;
    lbtipo_aliquota.SetParentComponent(Self);
    lbtipo_aliquota.Name := 'lbtipo_aliquota';
    lbtipo_aliquota.Left := 7;
    lbtipo_aliquota.Top := 498;
    lbtipo_aliquota.Width := 66;
    lbtipo_aliquota.Height := 13;
    lbtipo_aliquota.Caption := 'Tipo Al'#237'quota:';
    lbtipo_aliquota.HeightPercent := 100.000000000000000000;
    lbtipo_aliquota.WidthPercent := 100.000000000000000000;
    lbpRedIBS.SetParentComponent(Self);
    lbpRedIBS.Name := 'lbpRedIBS';
    lbpRedIBS.Left := 263;
    lbpRedIBS.Top := 525;
    lbpRedIBS.Width := 45;
    lbpRedIBS.Height := 13;
    lbpRedIBS.Caption := 'pRedIBS:';
    lbpRedIBS.HeightPercent := 100.000000000000000000;
    lbpRedIBS.WidthPercent := 100.000000000000000000;
    lbdata_atualizacao.SetParentComponent(Self);
    lbdata_atualizacao.Name := 'lbdata_atualizacao';
    lbdata_atualizacao.Left := 7;
    lbdata_atualizacao.Top := 526;
    lbdata_atualizacao.Width := 85;
    lbdata_atualizacao.Height := 13;
    lbdata_atualizacao.Caption := 'Data Atualiza'#231#227'o:';
    lbdata_atualizacao.HeightPercent := 100.000000000000000000;
    lbdata_atualizacao.WidthPercent := 100.000000000000000000;
    lbindNFe.SetParentComponent(Self);
    lbindNFe.Name := 'lbindNFe';
    lbindNFe.Left := 486;
    lbindNFe.Top := 415;
    lbindNFe.Width := 38;
    lbindNFe.Height := 13;
    lbindNFe.Caption := 'indNFe?';
    lbindNFe.HeightPercent := 100.000000000000000000;
    lbindNFe.WidthPercent := 100.000000000000000000;
    lbindNFCe.SetParentComponent(Self);
    lbindNFCe.Name := 'lbindNFCe';
    lbindNFCe.Left := 486;
    lbindNFCe.Top := 445;
    lbindNFCe.Width := 45;
    lbindNFCe.Height := 13;
    lbindNFCe.Caption := 'indNFCe?';
    lbindNFCe.HeightPercent := 100.000000000000000000;
    lbindNFCe.WidthPercent := 100.000000000000000000;
    lbindNFSe.SetParentComponent(Self);
    lbindNFSe.Name := 'lbindNFSe';
    lbindNFSe.Left := 487;
    lbindNFSe.Top := 470;
    lbindNFSe.Width := 44;
    lbindNFSe.Height := 13;
    lbindNFSe.Caption := 'indNFSe?';
    lbindNFSe.HeightPercent := 100.000000000000000000;
    lbindNFSe.WidthPercent := 100.000000000000000000;
    lbind_gEstornoCred.SetParentComponent(Self);
    lbind_gEstornoCred.Name := 'lbind_gEstornoCred';
    lbind_gEstornoCred.Left := 486;
    lbind_gEstornoCred.Top := 493;
    lbind_gEstornoCred.Width := 91;
    lbind_gEstornoCred.Height := 13;
    lbind_gEstornoCred.Caption := 'ind_gEstornoCred?';
    lbind_gEstornoCred.HeightPercent := 100.000000000000000000;
    lbind_gEstornoCred.WidthPercent := 100.000000000000000000;
    lbind_gCredPresOper.SetParentComponent(Self);
    lbind_gCredPresOper.Name := 'lbind_gCredPresOper';
    lbind_gCredPresOper.Left := 487;
    lbind_gCredPresOper.Top := 517;
    lbind_gCredPresOper.Width := 99;
    lbind_gCredPresOper.Height := 13;
    lbind_gCredPresOper.Caption := 'ind_gCredPresOper?';
    lbind_gCredPresOper.HeightPercent := 100.000000000000000000;
    lbind_gCredPresOper.WidthPercent := 100.000000000000000000;
    lbind_gMonoPadrao.SetParentComponent(Self);
    lbind_gMonoPadrao.Name := 'lbind_gMonoPadrao';
    lbind_gMonoPadrao.Left := 486;
    lbind_gMonoPadrao.Top := 541;
    lbind_gMonoPadrao.Width := 91;
    lbind_gMonoPadrao.Height := 13;
    lbind_gMonoPadrao.Caption := 'ind_gMonoPadrao?';
    lbind_gMonoPadrao.HeightPercent := 100.000000000000000000;
    lbind_gMonoPadrao.WidthPercent := 100.000000000000000000;
    lbind_gMonoReten.SetParentComponent(Self);
    lbind_gMonoReten.Name := 'lbind_gMonoReten';
    lbind_gMonoReten.Left := 487;
    lbind_gMonoReten.Top := 565;
    lbind_gMonoReten.Width := 86;
    lbind_gMonoReten.Height := 13;
    lbind_gMonoReten.Caption := 'ind_gMonoReten?';
    lbind_gMonoReten.HeightPercent := 100.000000000000000000;
    lbind_gMonoReten.WidthPercent := 100.000000000000000000;
    lbind_gMonoRet.SetParentComponent(Self);
    lbind_gMonoRet.Name := 'lbind_gMonoRet';
    lbind_gMonoRet.Left := 486;
    lbind_gMonoRet.Top := 589;
    lbind_gMonoRet.Width := 74;
    lbind_gMonoRet.Height := 13;
    lbind_gMonoRet.Caption := 'ind_gMonoRet?';
    lbind_gMonoRet.HeightPercent := 100.000000000000000000;
    lbind_gMonoRet.WidthPercent := 100.000000000000000000;
    lbind_gpBioDiferenca.SetParentComponent(Self);
    lbind_gpBioDiferenca.Name := 'lbind_gpBioDiferenca';
    lbind_gpBioDiferenca.Left := 487;
    lbind_gpBioDiferenca.Top := 613;
    lbind_gpBioDiferenca.Width := 97;
    lbind_gpBioDiferenca.Height := 13;
    lbind_gpBioDiferenca.Caption := 'ind_gpBioDiferenca?';
    lbind_gpBioDiferenca.HeightPercent := 100.000000000000000000;
    lbind_gpBioDiferenca.WidthPercent := 100.000000000000000000;
    lbtpRBSN.SetParentComponent(Self);
    lbtpRBSN.Name := 'lbtpRBSN';
    lbtpRBSN.Left := 487;
    lbtpRBSN.Top := 363;
    lbtpRBSN.Width := 40;
    lbtpRBSN.Height := 13;
    lbtpRBSN.Caption := 'tpRBSN:';
    lbtpRBSN.HeightPercent := 100.000000000000000000;
    lbtpRBSN.WidthPercent := 100.000000000000000000;
    lbtpDoacao.SetParentComponent(Self);
    lbtpDoacao.Name := 'lbtpDoacao';
    lbtpDoacao.Left := 264;
    lbtpDoacao.Top := 552;
    lbtpDoacao.Width := 50;
    lbtpDoacao.Height := 13;
    lbtpDoacao.Caption := 'tpDoacao:';
    lbtpDoacao.HeightPercent := 100.000000000000000000;
    lbtpDoacao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 289;
    btCancel.Top := 95;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 289;
    btSave.Top := 64;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 61;
    edid.Top := 29;
    edid.Width := 81;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edcst.SetParentComponent(Self);
    edcst.Name := 'edcst';
    edcst.Left := 61;
    edcst.Top := 56;
    edcst.Width := 81;
    edcst.Height := 21;
    edcst.HeightPercent := 100.000000000000000000;
    edcst.MaxLength := 3;
    edcst.TabOrder := 7;
    edcst.Text := 'edcst';
    edcst.WidthPercent := 100.000000000000000000;
    SetEvent(edcst, Self, 'OnClick', 'edcstClick');
    SetEvent(edcst, Self, 'OnKeyPress', 'edcstKeyPress');
    edcst.DataField := 'cst';
    edcst.DataSource := DataSource;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 61;
    eddescricao.Top := 83;
    eddescricao.Width := 81;
    eddescricao.Height := 21;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 8;
    eddescricao.Text := 'eddescricao';
    eddescricao.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao, Self, 'OnClick', 'eddescricaoClick');
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 61;
    edinclusao.Top := 137;
    edinclusao.Width := 81;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 10;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 61;
    edalteracao.Top := 164;
    edalteracao.Width := 81;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 11;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 61;
    edexclusao.Top := 191;
    edexclusao.Width := 81;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 12;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 61;
    cbExcluido.Top := 109;
    cbExcluido.Width := 81;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    pnlEspacoFormRt_Ibs_Cbs_Cst.SetParentComponent(Self);
    pnlEspacoFormRt_Ibs_Cbs_Cst.Name := 'pnlEspacoFormRt_Ibs_Cbs_Cst';
    pnlEspacoFormRt_Ibs_Cbs_Cst.Left := 8;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Top := 8;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Width := 379;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Height := 17;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Caption := 'Espa'#231'o form Rt Ibs Cbs Cst';
    pnlEspacoFormRt_Ibs_Cbs_Cst.ChildOrder := 23;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Color := clInfoText;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Font.Color := clWhite;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Font.Height := -11;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Font.Name := 'Tahoma';
    pnlEspacoFormRt_Ibs_Cbs_Cst.Font.Style := [fsBold];
    pnlEspacoFormRt_Ibs_Cbs_Cst.ParentFont := False;
    pnlEspacoFormRt_Ibs_Cbs_Cst.TabOrder := 9;
    pnlEspacoFormRt_Ibs_Cbs_Cst.Visible := False;
    btnRt_Ibs_Cbs_Cst.SetParentComponent(Self);
    btnRt_Ibs_Cbs_Cst.Name := 'btnRt_Ibs_Cbs_Cst';
    btnRt_Ibs_Cbs_Cst.Left := 289;
    btnRt_Ibs_Cbs_Cst.Top := 31;
    btnRt_Ibs_Cbs_Cst.Width := 96;
    btnRt_Ibs_Cbs_Cst.Height := 25;
    btnRt_Ibs_Cbs_Cst.Caption := 'IBS CBS CST';
    btnRt_Ibs_Cbs_Cst.ChildOrder := 16;
    btnRt_Ibs_Cbs_Cst.HeightPercent := 100.000000000000000000;
    btnRt_Ibs_Cbs_Cst.WidthPercent := 100.000000000000000000;
    btnIbsCbsClassTributaria.SetParentComponent(Self);
    btnIbsCbsClassTributaria.Name := 'btnIbsCbsClassTributaria';
    btnIbsCbsClassTributaria.Left := 695;
    btnIbsCbsClassTributaria.Top := 27;
    btnIbsCbsClassTributaria.Width := 96;
    btnIbsCbsClassTributaria.Height := 25;
    btnIbsCbsClassTributaria.Caption := 'Classifica'#231#227'o Tribut'#225'ria';
    btnIbsCbsClassTributaria.ChildOrder := 16;
    btnIbsCbsClassTributaria.HeightPercent := 100.000000000000000000;
    btnIbsCbsClassTributaria.WidthPercent := 100.000000000000000000;
    SetEvent(btnIbsCbsClassTributaria, Self, 'OnClick', 'btnIbsCbsClassTributariaClick');
    pnlIbsCbsClassTributaria.SetParentComponent(Self);
    pnlIbsCbsClassTributaria.Name := 'pnlIbsCbsClassTributaria';
    pnlIbsCbsClassTributaria.Left := 448;
    pnlIbsCbsClassTributaria.Top := 8;
    pnlIbsCbsClassTributaria.Width := 343;
    pnlIbsCbsClassTributaria.Height := 17;
    pnlIbsCbsClassTributaria.Caption := 'Espa'#231'o tabela Rt Ibs Cbs Class Tributaria';
    pnlIbsCbsClassTributaria.ChildOrder := 23;
    pnlIbsCbsClassTributaria.Color := clInfoText;
    pnlIbsCbsClassTributaria.Font.Charset := DEFAULT_CHARSET;
    pnlIbsCbsClassTributaria.Font.Color := clWhite;
    pnlIbsCbsClassTributaria.Font.Height := -11;
    pnlIbsCbsClassTributaria.Font.Name := 'Tahoma';
    pnlIbsCbsClassTributaria.Font.Style := [fsBold];
    pnlIbsCbsClassTributaria.ParentFont := False;
    pnlIbsCbsClassTributaria.TabOrder := 12;
    pnlIbsCbsClassTributaria.Visible := False;
    cbPageSizeIbsCbsClassTributaria.SetParentComponent(Self);
    cbPageSizeIbsCbsClassTributaria.Name := 'cbPageSizeIbsCbsClassTributaria';
    cbPageSizeIbsCbsClassTributaria.Left := 592;
    cbPageSizeIbsCbsClassTributaria.Top := 31;
    cbPageSizeIbsCbsClassTributaria.Width := 97;
    cbPageSizeIbsCbsClassTributaria.Height := 21;
    cbPageSizeIbsCbsClassTributaria.HeightPercent := 100.000000000000000000;
    cbPageSizeIbsCbsClassTributaria.TabOrder := 2;
    cbPageSizeIbsCbsClassTributaria.Text := '10';
    cbPageSizeIbsCbsClassTributaria.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeIbsCbsClassTributaria, Self, 'OnChange', 'cbPageSizeIbsCbsClassTributariaChange');
    cbPageSizeIbsCbsClassTributaria.ItemIndex := 0;
    cbPageSizeIbsCbsClassTributaria.Items.BeginUpdate;
    try
      cbPageSizeIbsCbsClassTributaria.Items.Clear;
      cbPageSizeIbsCbsClassTributaria.Items.Add('10');
      cbPageSizeIbsCbsClassTributaria.Items.Add('25');
      cbPageSizeIbsCbsClassTributaria.Items.Add('50');
      cbPageSizeIbsCbsClassTributaria.Items.Add('100');
    finally
      cbPageSizeIbsCbsClassTributaria.Items.EndUpdate;
    end;
    IbsCbsClassTributariaSearch.SetParentComponent(Self);
    IbsCbsClassTributariaSearch.Name := 'IbsCbsClassTributariaSearch';
    IbsCbsClassTributariaSearch.Left := 456;
    IbsCbsClassTributariaSearch.Top := 31;
    IbsCbsClassTributariaSearch.Width := 88;
    IbsCbsClassTributariaSearch.Height := 21;
    IbsCbsClassTributariaSearch.ChildOrder := 21;
    IbsCbsClassTributariaSearch.HeightPercent := 100.000000000000000000;
    IbsCbsClassTributariaSearch.TabOrder := 3;
    IbsCbsClassTributariaSearch.WidthPercent := 100.000000000000000000;
    SetEvent(IbsCbsClassTributariaSearch, Self, 'OnKeyDown', 'IbsCbsClassTributariaSearchKeyDown');
    SetEvent(IbsCbsClassTributariaSearch, Self, 'OnKeyUp', 'IbsCbsClassTributariaSearchKeyUp');
    tblIbsCbsClassTributaria.SetParentComponent(Self);
    tblIbsCbsClassTributaria.Name := 'tblIbsCbsClassTributaria';
    tblIbsCbsClassTributaria.Left := 456;
    tblIbsCbsClassTributaria.Top := 58;
    tblIbsCbsClassTributaria.Width := 335;
    tblIbsCbsClassTributaria.Height := 143;
    tblIbsCbsClassTributaria.ElementClassName := 'table-responsive';
    tblIbsCbsClassTributaria.BorderColor := clSilver;
    tblIbsCbsClassTributaria.ChildOrder := 19;
    tblIbsCbsClassTributaria.ColHeader := False;
    tblIbsCbsClassTributaria.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblIbsCbsClassTributaria, Self, 'OnGetCellData', 'tblIbsCbsClassTributariaGetCellData');
    SetEvent(tblIbsCbsClassTributaria, Self, 'OnGetCellChildren', 'tblIbsCbsClassTributariaGetCellChildren');
    SetEvent(tblIbsCbsClassTributaria, Self, 'OnGetCellClass', 'tblIbsCbsClassTributariaGetCellClass');
    tblIbsCbsClassTributaria.Columns.Clear;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'cclasstrib';
      Title := 'CClassTrib';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'nome_cClassTrib';
      Title := 'nome cClassTrib';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'data_inicio';
      Title := 'Data In'#237'cio';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'data_fim';
      Title := 'Data Fim';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with tblIbsCbsClassTributaria.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    tblIbsCbsClassTributaria.DataSource := dtsIbsCbsClassTributaria;
    wlcIbsCbsClassTributaria.SetParentComponent(Self);
    wlcIbsCbsClassTributaria.Name := 'wlcIbsCbsClassTributaria';
    wlcIbsCbsClassTributaria.Left := 603;
    wlcIbsCbsClassTributaria.Top := 216;
    wlcIbsCbsClassTributaria.Width := 188;
    wlcIbsCbsClassTributaria.Height := 15;
    wlcIbsCbsClassTributaria.HeightPercent := 100.000000000000000000;
    wlcIbsCbsClassTributaria.WidthPercent := 100.000000000000000000;
    wlcIbsCbsClassTributaria.ChildOrder := 24;
    wlcIbsCbsClassTributaria.DefaultItemClassName := 'page-item';
    wlcIbsCbsClassTributaria.DefaultItemLinkClassName := 'page-link';
    wlcIbsCbsClassTributaria.ElementListClassName := 'pagination';
    wlcIbsCbsClassTributaria.Items.Clear;
    with wlcIbsCbsClassTributaria.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcIbsCbsClassTributaria.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcIbsCbsClassTributaria.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcIbsCbsClassTributaria.Style := lsPagination;
    pnlEspacoFormIbsCbsClassTributaria.SetParentComponent(Self);
    pnlEspacoFormIbsCbsClassTributaria.Name := 'pnlEspacoFormIbsCbsClassTributaria';
    pnlEspacoFormIbsCbsClassTributaria.Left := 8;
    pnlEspacoFormIbsCbsClassTributaria.Top := 312;
    pnlEspacoFormIbsCbsClassTributaria.Width := 787;
    pnlEspacoFormIbsCbsClassTributaria.Height := 17;
    pnlEspacoFormIbsCbsClassTributaria.Caption := 'Espa'#231'o form Rt Ibs Cbs Class Tributaria';
    pnlEspacoFormIbsCbsClassTributaria.ChildOrder := 23;
    pnlEspacoFormIbsCbsClassTributaria.Color := clInfoText;
    pnlEspacoFormIbsCbsClassTributaria.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoFormIbsCbsClassTributaria.Font.Color := clWhite;
    pnlEspacoFormIbsCbsClassTributaria.Font.Height := -11;
    pnlEspacoFormIbsCbsClassTributaria.Font.Name := 'Tahoma';
    pnlEspacoFormIbsCbsClassTributaria.Font.Style := [fsBold];
    pnlEspacoFormIbsCbsClassTributaria.ParentFont := False;
    pnlEspacoFormIbsCbsClassTributaria.TabOrder := 17;
    pnlEspacoFormIbsCbsClassTributaria.Visible := False;
    edid_classtrib.SetParentComponent(Self);
    edid_classtrib.Name := 'edid_classtrib';
    edid_classtrib.Left := 149;
    edid_classtrib.Top := 333;
    edid_classtrib.Width := 92;
    edid_classtrib.Height := 21;
    edid_classtrib.ChildOrder := 27;
    edid_classtrib.Enabled := False;
    edid_classtrib.HeightPercent := 100.000000000000000000;
    edid_classtrib.TabOrder := 6;
    edid_classtrib.Text := 'edid';
    edid_classtrib.WidthPercent := 100.000000000000000000;
    edid_classtrib.DataField := 'id';
    edid_classtrib.DataSource := dtsIbsCbsClassTributariaEdit;
    edcclasstrib.SetParentComponent(Self);
    edcclasstrib.Name := 'edcclasstrib';
    edcclasstrib.Left := 149;
    edcclasstrib.Top := 387;
    edcclasstrib.Width := 92;
    edcclasstrib.Height := 21;
    edcclasstrib.ChildOrder := 31;
    edcclasstrib.HeightPercent := 100.000000000000000000;
    edcclasstrib.MaxLength := 6;
    edcclasstrib.TabOrder := 8;
    edcclasstrib.Text := 'edcclasstrib';
    edcclasstrib.WidthPercent := 100.000000000000000000;
    SetEvent(edcclasstrib, Self, 'OnClick', 'edcclasstribClick');
    SetEvent(edcclasstrib, Self, 'OnKeyPress', 'edcclasstribKeyPress');
    edcclasstrib.DataField := 'cclasstrib';
    edcclasstrib.DataSource := dtsIbsCbsClassTributariaEdit;
    eddescricao_classtrib.SetParentComponent(Self);
    eddescricao_classtrib.Name := 'eddescricao_classtrib';
    eddescricao_classtrib.Left := 149;
    eddescricao_classtrib.Top := 414;
    eddescricao_classtrib.Width := 92;
    eddescricao_classtrib.Height := 21;
    eddescricao_classtrib.ChildOrder := 33;
    eddescricao_classtrib.HeightPercent := 100.000000000000000000;
    eddescricao_classtrib.TabOrder := 9;
    eddescricao_classtrib.Text := 'eddescricao';
    eddescricao_classtrib.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao_classtrib, Self, 'OnClick', 'eddescricao_classtribClick');
    eddescricao_classtrib.DataField := 'descricao';
    eddescricao_classtrib.DataSource := dtsIbsCbsClassTributariaEdit;
    edlei_complementar.SetParentComponent(Self);
    edlei_complementar.Name := 'edlei_complementar';
    edlei_complementar.Left := 149;
    edlei_complementar.Top := 441;
    edlei_complementar.Width := 92;
    edlei_complementar.Height := 21;
    edlei_complementar.ChildOrder := 35;
    edlei_complementar.HeightPercent := 100.000000000000000000;
    edlei_complementar.TabOrder := 10;
    edlei_complementar.Text := 'edlei_complementar';
    edlei_complementar.WidthPercent := 100.000000000000000000;
    edlei_complementar.DataField := 'lei_complementar';
    edlei_complementar.DataSource := dtsIbsCbsClassTributariaEdit;
    edlei_complementar_redacao.SetParentComponent(Self);
    edlei_complementar_redacao.Name := 'edlei_complementar_redacao';
    edlei_complementar_redacao.Left := 149;
    edlei_complementar_redacao.Top := 468;
    edlei_complementar_redacao.Width := 92;
    edlei_complementar_redacao.Height := 21;
    edlei_complementar_redacao.ChildOrder := 37;
    edlei_complementar_redacao.HeightPercent := 100.000000000000000000;
    edlei_complementar_redacao.TabOrder := 11;
    edlei_complementar_redacao.Text := 'edlei_complementar_redacao';
    edlei_complementar_redacao.WidthPercent := 100.000000000000000000;
    edlei_complementar_redacao.DataField := 'lei_complementar_redacao';
    edlei_complementar_redacao.DataSource := dtsIbsCbsClassTributariaEdit;
    edinclusao_classtrib.SetParentComponent(Self);
    edinclusao_classtrib.Name := 'edinclusao_classtrib';
    edinclusao_classtrib.Left := 357;
    edinclusao_classtrib.Top := 414;
    edinclusao_classtrib.Width := 99;
    edinclusao_classtrib.Height := 21;
    edinclusao_classtrib.ChildOrder := 45;
    edinclusao_classtrib.Enabled := False;
    edinclusao_classtrib.HeightPercent := 100.000000000000000000;
    edinclusao_classtrib.TabOrder := 15;
    edinclusao_classtrib.Text := 'edinclusao';
    edinclusao_classtrib.WidthPercent := 100.000000000000000000;
    edinclusao_classtrib.DataField := 'inclusao';
    edinclusao_classtrib.DataSource := dtsIbsCbsClassTributariaEdit;
    edalteracao_classtrib.SetParentComponent(Self);
    edalteracao_classtrib.Name := 'edalteracao_classtrib';
    edalteracao_classtrib.Left := 357;
    edalteracao_classtrib.Top := 441;
    edalteracao_classtrib.Width := 99;
    edalteracao_classtrib.Height := 21;
    edalteracao_classtrib.ChildOrder := 47;
    edalteracao_classtrib.Enabled := False;
    edalteracao_classtrib.HeightPercent := 100.000000000000000000;
    edalteracao_classtrib.TabOrder := 16;
    edalteracao_classtrib.Text := 'edalteracao';
    edalteracao_classtrib.WidthPercent := 100.000000000000000000;
    edalteracao_classtrib.DataField := 'alteracao';
    edalteracao_classtrib.DataSource := dtsIbsCbsClassTributariaEdit;
    ed_exclusao.SetParentComponent(Self);
    ed_exclusao.Name := 'ed_exclusao';
    ed_exclusao.Left := 357;
    ed_exclusao.Top := 468;
    ed_exclusao.Width := 99;
    ed_exclusao.Height := 21;
    ed_exclusao.ChildOrder := 49;
    ed_exclusao.Enabled := False;
    ed_exclusao.HeightPercent := 100.000000000000000000;
    ed_exclusao.TabOrder := 17;
    ed_exclusao.Text := 'edexclusao';
    ed_exclusao.WidthPercent := 100.000000000000000000;
    ed_exclusao.DataField := 'exclusao';
    ed_exclusao.DataSource := dtsIbsCbsClassTributariaEdit;
    cbExcluidoClassTrib.SetParentComponent(Self);
    cbExcluidoClassTrib.Name := 'cbExcluidoClassTrib';
    cbExcluidoClassTrib.Left := 357;
    cbExcluidoClassTrib.Top := 386;
    cbExcluidoClassTrib.Width := 99;
    cbExcluidoClassTrib.Height := 22;
    cbExcluidoClassTrib.Caption := 'cbExcluido';
    cbExcluidoClassTrib.ChildOrder := 13;
    cbExcluidoClassTrib.HeightPercent := 100.000000000000000000;
    cbExcluidoClassTrib.WidthPercent := 100.000000000000000000;
    cbExcluidoClassTrib.DataField := 'excluido';
    cbExcluidoClassTrib.DataSource := dtsIbsCbsClassTributariaEdit;
    cbbIbsCbsCstId.SetParentComponent(Self);
    cbbIbsCbsCstId.Name := 'cbbIbsCbsCstId';
    cbbIbsCbsCstId.Left := 149;
    cbbIbsCbsCstId.Top := 360;
    cbbIbsCbsCstId.Width := 92;
    cbbIbsCbsCstId.Height := 21;
    cbbIbsCbsCstId.HeightPercent := 100.000000000000000000;
    cbbIbsCbsCstId.WidthPercent := 100.000000000000000000;
    SetEvent(cbbIbsCbsCstId, Self, 'OnClick', 'cbbIbsCbsCstIdClick');
    cbbIbsCbsCstId.ItemIndex := -1;
    btnNovo.SetParentComponent(Self);
    btnNovo.Name := 'btnNovo';
    btnNovo.Left := 696;
    btnNovo.Top := 331;
    btnNovo.Width := 99;
    btnNovo.Height := 25;
    btnNovo.Caption := 'Novo';
    btnNovo.ChildOrder := 50;
    btnNovo.HeightPercent := 100.000000000000000000;
    btnNovo.WidthPercent := 100.000000000000000000;
    SetEvent(btnNovo, Self, 'OnClick', 'btnNovoClick');
    eddata_inicio.SetParentComponent(Self);
    eddata_inicio.Name := 'eddata_inicio';
    eddata_inicio.Left := 357;
    eddata_inicio.Top := 332;
    eddata_inicio.Width := 99;
    eddata_inicio.Height := 22;
    eddata_inicio.BorderStyle := bsSingle;
    eddata_inicio.ChildOrder := 62;
    eddata_inicio.Color := clWhite;
    eddata_inicio.Date := 45775.510139409720000000;
    eddata_inicio.Role := '';
    eddata_inicio.ShowSeconds := False;
    eddata_inicio.Text := '';
    eddata_inicio.DataField := 'data_inicio';
    eddata_inicio.DataSource := dtsIbsCbsClassTributariaEdit;
    eddata_fim.SetParentComponent(Self);
    eddata_fim.Name := 'eddata_fim';
    eddata_fim.Left := 357;
    eddata_fim.Top := 358;
    eddata_fim.Width := 99;
    eddata_fim.Height := 22;
    eddata_fim.BorderStyle := bsSingle;
    eddata_fim.ChildOrder := 62;
    eddata_fim.Color := clWhite;
    eddata_fim.Date := 45775.510139409720000000;
    eddata_fim.Role := '';
    eddata_fim.ShowSeconds := False;
    eddata_fim.Text := '';
    SetEvent(eddata_fim, Self, 'OnClick', 'eddata_fimClick');
    eddata_fim.DataField := 'data_fim';
    eddata_fim.DataSource := dtsIbsCbsClassTributariaEdit;
    btnSalvarClassTrib.SetParentComponent(Self);
    btnSalvarClassTrib.Name := 'btnSalvarClassTrib';
    btnSalvarClassTrib.Left := 696;
    btnSalvarClassTrib.Top := 362;
    btnSalvarClassTrib.Width := 99;
    btnSalvarClassTrib.Height := 25;
    btnSalvarClassTrib.Caption := 'Salvar';
    btnSalvarClassTrib.ChildOrder := 51;
    btnSalvarClassTrib.HeightPercent := 100.000000000000000000;
    btnSalvarClassTrib.TabOrder := 4;
    btnSalvarClassTrib.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarClassTrib, Self, 'OnClick', 'btnSalvarClassTribClick');
    edind_gIBSCBS.SetParentComponent(Self);
    edind_gIBSCBS.Name := 'edind_gIBSCBS';
    edind_gIBSCBS.Left := 201;
    edind_gIBSCBS.Top := 29;
    edind_gIBSCBS.Width := 81;
    edind_gIBSCBS.Height := 21;
    edind_gIBSCBS.ChildOrder := 55;
    edind_gIBSCBS.HeightPercent := 100.000000000000000000;
    edind_gIBSCBS.MaxLength := 1;
    edind_gIBSCBS.TabOrder := 7;
    edind_gIBSCBS.Text := 'ind_gIBSCBS';
    edind_gIBSCBS.WidthPercent := 100.000000000000000000;
    edind_gIBSCBS.DataField := 'ind_gIBSCBS';
    edind_gIBSCBS.DataSource := DataSource;
    edind_gIBSCBSMono.SetParentComponent(Self);
    edind_gIBSCBSMono.Name := 'edind_gIBSCBSMono';
    edind_gIBSCBSMono.Left := 202;
    edind_gIBSCBSMono.Top := 56;
    edind_gIBSCBSMono.Width := 81;
    edind_gIBSCBSMono.Height := 21;
    edind_gIBSCBSMono.ChildOrder := 55;
    edind_gIBSCBSMono.HeightPercent := 100.000000000000000000;
    edind_gIBSCBSMono.MaxLength := 1;
    edind_gIBSCBSMono.TabOrder := 7;
    edind_gIBSCBSMono.Text := 'ind_gIBSCBSMono';
    edind_gIBSCBSMono.WidthPercent := 100.000000000000000000;
    edind_gIBSCBSMono.DataField := 'ind_gIBSCBSMono';
    edind_gIBSCBSMono.DataSource := DataSource;
    edind_gRed.SetParentComponent(Self);
    edind_gRed.Name := 'edind_gRed';
    edind_gRed.Left := 202;
    edind_gRed.Top := 83;
    edind_gRed.Width := 81;
    edind_gRed.Height := 21;
    edind_gRed.ChildOrder := 55;
    edind_gRed.HeightPercent := 100.000000000000000000;
    edind_gRed.MaxLength := 1;
    edind_gRed.TabOrder := 7;
    edind_gRed.Text := 'ind_gRed';
    edind_gRed.WidthPercent := 100.000000000000000000;
    edind_gRed.DataField := 'ind_gRed';
    edind_gRed.DataSource := DataSource;
    edind_gDif.SetParentComponent(Self);
    edind_gDif.Name := 'edind_gDif';
    edind_gDif.Left := 202;
    edind_gDif.Top := 110;
    edind_gDif.Width := 81;
    edind_gDif.Height := 21;
    edind_gDif.ChildOrder := 55;
    edind_gDif.HeightPercent := 100.000000000000000000;
    edind_gDif.MaxLength := 1;
    edind_gDif.TabOrder := 7;
    edind_gDif.Text := 'ind_gDif';
    edind_gDif.WidthPercent := 100.000000000000000000;
    edind_gDif.DataField := 'ind_gDif';
    edind_gDif.DataSource := DataSource;
    edind_gTransfCred.SetParentComponent(Self);
    edind_gTransfCred.Name := 'edind_gTransfCred';
    edind_gTransfCred.Left := 201;
    edind_gTransfCred.Top := 137;
    edind_gTransfCred.Width := 81;
    edind_gTransfCred.Height := 21;
    edind_gTransfCred.ChildOrder := 55;
    edind_gTransfCred.HeightPercent := 100.000000000000000000;
    edind_gTransfCred.MaxLength := 1;
    edind_gTransfCred.TabOrder := 7;
    edind_gTransfCred.Text := 'ind_gTransfCred';
    edind_gTransfCred.WidthPercent := 100.000000000000000000;
    edind_gTransfCred.DataField := 'ind_gTransfCred';
    edind_gTransfCred.DataSource := DataSource;
    cbind_gCredPresIBSZFM.SetParentComponent(Self);
    cbind_gCredPresIBSZFM.Name := 'cbind_gCredPresIBSZFM';
    cbind_gCredPresIBSZFM.Left := 266;
    cbind_gCredPresIBSZFM.Top := 164;
    cbind_gCredPresIBSZFM.Width := 81;
    cbind_gCredPresIBSZFM.Height := 22;
    cbind_gCredPresIBSZFM.Caption := 'ind_gCredPresIBSZFM';
    cbind_gCredPresIBSZFM.ChildOrder := 13;
    cbind_gCredPresIBSZFM.HeightPercent := 100.000000000000000000;
    cbind_gCredPresIBSZFM.WidthPercent := 100.000000000000000000;
    cbind_gCredPresIBSZFM.DataField := 'ind_gCredPresIBSZFM';
    cbind_gCredPresIBSZFM.DataSource := DataSource;
    cbind_gAjusteCompet.SetParentComponent(Self);
    cbind_gAjusteCompet.Name := 'cbind_gAjusteCompet';
    cbind_gAjusteCompet.Left := 266;
    cbind_gAjusteCompet.Top := 192;
    cbind_gAjusteCompet.Width := 81;
    cbind_gAjusteCompet.Height := 22;
    cbind_gAjusteCompet.Caption := 'ind_gAjusteCompet';
    cbind_gAjusteCompet.ChildOrder := 13;
    cbind_gAjusteCompet.HeightPercent := 100.000000000000000000;
    cbind_gAjusteCompet.WidthPercent := 100.000000000000000000;
    cbind_gAjusteCompet.DataField := 'ind_gAjusteCompet';
    cbind_gAjusteCompet.DataSource := DataSource;
    ednome_cClassTrib.SetParentComponent(Self);
    ednome_cClassTrib.Name := 'ednome_cClassTrib';
    ednome_cClassTrib.Left := 357;
    ednome_cClassTrib.Top := 495;
    ednome_cClassTrib.Width := 99;
    ednome_cClassTrib.Height := 21;
    ednome_cClassTrib.ChildOrder := 31;
    ednome_cClassTrib.HeightPercent := 100.000000000000000000;
    ednome_cClassTrib.TabOrder := 8;
    ednome_cClassTrib.Text := 'nome_cClassTrib';
    ednome_cClassTrib.WidthPercent := 100.000000000000000000;
    ednome_cClassTrib.DataField := 'nome_cClassTrib';
    ednome_cClassTrib.DataSource := dtsIbsCbsClassTributariaEdit;
    edpRedCBS.SetParentComponent(Self);
    edpRedCBS.Name := 'edpRedCBS';
    edpRedCBS.Left := 580;
    edpRedCBS.Top := 333;
    edpRedCBS.Width := 99;
    edpRedCBS.Height := 21;
    edpRedCBS.ChildOrder := 31;
    edpRedCBS.HeightPercent := 100.000000000000000000;
    edpRedCBS.MaxLength := 10;
    edpRedCBS.TabOrder := 8;
    edpRedCBS.Text := 'pRedCBS';
    edpRedCBS.WidthPercent := 100.000000000000000000;
    edpRedCBS.DataField := 'pRedCBS';
    edpRedCBS.DataSource := dtsIbsCbsClassTributariaEdit;
    edind_gTribRegular.SetParentComponent(Self);
    edind_gTribRegular.Name := 'edind_gTribRegular';
    edind_gTribRegular.Left := 580;
    edind_gTribRegular.Top := 387;
    edind_gTribRegular.Width := 99;
    edind_gTribRegular.Height := 21;
    edind_gTribRegular.ChildOrder := 31;
    edind_gTribRegular.HeightPercent := 100.000000000000000000;
    edind_gTribRegular.MaxLength := 1;
    edind_gTribRegular.TabOrder := 8;
    edind_gTribRegular.Text := 'ind_gTribRegular';
    edind_gTribRegular.WidthPercent := 100.000000000000000000;
    edind_gTribRegular.DataField := 'ind_gTribRegular';
    edind_gTribRegular.DataSource := dtsIbsCbsClassTributariaEdit;
    edtipo_aliquota.SetParentComponent(Self);
    edtipo_aliquota.Name := 'edtipo_aliquota';
    edtipo_aliquota.Left := 149;
    edtipo_aliquota.Top := 495;
    edtipo_aliquota.Width := 92;
    edtipo_aliquota.Height := 21;
    edtipo_aliquota.ChildOrder := 31;
    edtipo_aliquota.HeightPercent := 100.000000000000000000;
    edtipo_aliquota.MaxLength := 60;
    edtipo_aliquota.TabOrder := 8;
    edtipo_aliquota.Text := 'tipo_aliquota';
    edtipo_aliquota.WidthPercent := 100.000000000000000000;
    edtipo_aliquota.DataField := 'tipo_aliquota';
    edtipo_aliquota.DataSource := dtsIbsCbsClassTributariaEdit;
    edpRedIBS.SetParentComponent(Self);
    edpRedIBS.Name := 'edpRedIBS';
    edpRedIBS.Left := 357;
    edpRedIBS.Top := 522;
    edpRedIBS.Width := 99;
    edpRedIBS.Height := 21;
    edpRedIBS.ChildOrder := 31;
    edpRedIBS.HeightPercent := 100.000000000000000000;
    edpRedIBS.MaxLength := 10;
    edpRedIBS.TabOrder := 8;
    edpRedIBS.Text := 'pRedIBS';
    edpRedIBS.WidthPercent := 100.000000000000000000;
    edpRedIBS.DataField := 'pRedIBS';
    edpRedIBS.DataSource := dtsIbsCbsClassTributariaEdit;
    eddata_atualizacao.SetParentComponent(Self);
    eddata_atualizacao.Name := 'eddata_atualizacao';
    eddata_atualizacao.Left := 149;
    eddata_atualizacao.Top := 522;
    eddata_atualizacao.Width := 92;
    eddata_atualizacao.Height := 22;
    eddata_atualizacao.BorderStyle := bsSingle;
    eddata_atualizacao.ChildOrder := 62;
    eddata_atualizacao.Color := clWhite;
    eddata_atualizacao.Date := 45849.624158344910000000;
    eddata_atualizacao.Enabled := False;
    eddata_atualizacao.Role := '';
    eddata_atualizacao.ShowSeconds := False;
    eddata_atualizacao.Text := '';
    eddata_atualizacao.DataField := 'data_atualizacao';
    eddata_atualizacao.DataSource := dtsIbsCbsClassTributariaEdit;
    cbindNFe.SetParentComponent(Self);
    cbindNFe.Name := 'cbindNFe';
    cbindNFe.Left := 603;
    cbindNFe.Top := 411;
    cbindNFe.Width := 81;
    cbindNFe.Height := 22;
    cbindNFe.Caption := 'indNFe';
    cbindNFe.ChildOrder := 13;
    cbindNFe.HeightPercent := 100.000000000000000000;
    cbindNFe.WidthPercent := 100.000000000000000000;
    cbindNFe.DataField := 'indNFe';
    cbindNFe.DataSource := dtsIbsCbsClassTributariaEdit;
    cbindNFCe.SetParentComponent(Self);
    cbindNFCe.Name := 'cbindNFCe';
    cbindNFCe.Left := 603;
    cbindNFCe.Top := 441;
    cbindNFCe.Width := 81;
    cbindNFCe.Height := 22;
    cbindNFCe.Caption := 'indNFCe';
    cbindNFCe.ChildOrder := 13;
    cbindNFCe.HeightPercent := 100.000000000000000000;
    cbindNFCe.WidthPercent := 100.000000000000000000;
    cbindNFCe.DataField := 'indNFCe';
    cbindNFCe.DataSource := dtsIbsCbsClassTributariaEdit;
    cbindNFSe.SetParentComponent(Self);
    cbindNFSe.Name := 'cbindNFSe';
    cbindNFSe.Left := 604;
    cbindNFSe.Top := 466;
    cbindNFSe.Width := 81;
    cbindNFSe.Height := 22;
    cbindNFSe.Caption := 'indNFSe';
    cbindNFSe.ChildOrder := 13;
    cbindNFSe.HeightPercent := 100.000000000000000000;
    cbindNFSe.WidthPercent := 100.000000000000000000;
    cbindNFSe.DataField := 'indNFSe';
    cbindNFSe.DataSource := dtsIbsCbsClassTributariaEdit;
    cbind_gEstornoCred.SetParentComponent(Self);
    cbind_gEstornoCred.Name := 'cbind_gEstornoCred';
    cbind_gEstornoCred.Left := 603;
    cbind_gEstornoCred.Top := 489;
    cbind_gEstornoCred.Width := 81;
    cbind_gEstornoCred.Height := 22;
    cbind_gEstornoCred.Caption := 'ind_gEstornoCred';
    cbind_gEstornoCred.ChildOrder := 13;
    cbind_gEstornoCred.HeightPercent := 100.000000000000000000;
    cbind_gEstornoCred.WidthPercent := 100.000000000000000000;
    cbind_gEstornoCred.DataField := 'ind_gEstornoCred';
    cbind_gEstornoCred.DataSource := dtsIbsCbsClassTributariaEdit;
    cbind_gCredPresOper.SetParentComponent(Self);
    cbind_gCredPresOper.Name := 'cbind_gCredPresOper';
    cbind_gCredPresOper.Left := 604;
    cbind_gCredPresOper.Top := 513;
    cbind_gCredPresOper.Width := 81;
    cbind_gCredPresOper.Height := 22;
    cbind_gCredPresOper.Caption := 'ind_gCredPresOper';
    cbind_gCredPresOper.ChildOrder := 13;
    cbind_gCredPresOper.HeightPercent := 100.000000000000000000;
    cbind_gCredPresOper.WidthPercent := 100.000000000000000000;
    cbind_gCredPresOper.DataField := 'ind_gCredPresOper';
    cbind_gCredPresOper.DataSource := dtsIbsCbsClassTributariaEdit;
    cbind_gMonoPadrao.SetParentComponent(Self);
    cbind_gMonoPadrao.Name := 'cbind_gMonoPadrao';
    cbind_gMonoPadrao.Left := 603;
    cbind_gMonoPadrao.Top := 537;
    cbind_gMonoPadrao.Width := 81;
    cbind_gMonoPadrao.Height := 22;
    cbind_gMonoPadrao.Caption := 'ind_gMonoPadrao';
    cbind_gMonoPadrao.ChildOrder := 13;
    cbind_gMonoPadrao.HeightPercent := 100.000000000000000000;
    cbind_gMonoPadrao.WidthPercent := 100.000000000000000000;
    cbind_gMonoPadrao.DataField := 'ind_gMonoPadrao';
    cbind_gMonoPadrao.DataSource := dtsIbsCbsClassTributariaEdit;
    cbind_gMonoReten.SetParentComponent(Self);
    cbind_gMonoReten.Name := 'cbind_gMonoReten';
    cbind_gMonoReten.Left := 604;
    cbind_gMonoReten.Top := 561;
    cbind_gMonoReten.Width := 81;
    cbind_gMonoReten.Height := 22;
    cbind_gMonoReten.Caption := 'ind_gMonoReten';
    cbind_gMonoReten.ChildOrder := 13;
    cbind_gMonoReten.HeightPercent := 100.000000000000000000;
    cbind_gMonoReten.WidthPercent := 100.000000000000000000;
    cbind_gMonoReten.DataField := 'ind_gMonoReten';
    cbind_gMonoReten.DataSource := dtsIbsCbsClassTributariaEdit;
    cbind_gMonoRet.SetParentComponent(Self);
    cbind_gMonoRet.Name := 'cbind_gMonoRet';
    cbind_gMonoRet.Left := 603;
    cbind_gMonoRet.Top := 585;
    cbind_gMonoRet.Width := 81;
    cbind_gMonoRet.Height := 22;
    cbind_gMonoRet.Caption := 'ind_gMonoRet';
    cbind_gMonoRet.ChildOrder := 13;
    cbind_gMonoRet.HeightPercent := 100.000000000000000000;
    cbind_gMonoRet.WidthPercent := 100.000000000000000000;
    cbind_gMonoRet.DataField := 'ind_gMonoRet';
    cbind_gMonoRet.DataSource := dtsIbsCbsClassTributariaEdit;
    cbind_gpBioDiferenca.SetParentComponent(Self);
    cbind_gpBioDiferenca.Name := 'cbind_gpBioDiferenca';
    cbind_gpBioDiferenca.Left := 604;
    cbind_gpBioDiferenca.Top := 609;
    cbind_gpBioDiferenca.Width := 81;
    cbind_gpBioDiferenca.Height := 22;
    cbind_gpBioDiferenca.Caption := 'ind_gpBioDiferenca';
    cbind_gpBioDiferenca.ChildOrder := 13;
    cbind_gpBioDiferenca.HeightPercent := 100.000000000000000000;
    cbind_gpBioDiferenca.WidthPercent := 100.000000000000000000;
    cbind_gpBioDiferenca.DataField := 'ind_gpBioDiferenca';
    cbind_gpBioDiferenca.DataSource := dtsIbsCbsClassTributariaEdit;
    cbind_RedutorBC.SetParentComponent(Self);
    cbind_RedutorBC.Name := 'cbind_RedutorBC';
    cbind_RedutorBC.Left := 266;
    cbind_RedutorBC.Top := 220;
    cbind_RedutorBC.Width := 81;
    cbind_RedutorBC.Height := 22;
    cbind_RedutorBC.Caption := 'ind_RedutorBC';
    cbind_RedutorBC.ChildOrder := 13;
    cbind_RedutorBC.HeightPercent := 100.000000000000000000;
    cbind_RedutorBC.WidthPercent := 100.000000000000000000;
    cbind_RedutorBC.DataField := 'ind_RedutorBC';
    cbind_RedutorBC.DataSource := DataSource;
    edtpRBSN.SetParentComponent(Self);
    edtpRBSN.Name := 'edtpRBSN';
    edtpRBSN.Left := 580;
    edtpRBSN.Top := 360;
    edtpRBSN.Width := 99;
    edtpRBSN.Height := 21;
    edtpRBSN.ChildOrder := 31;
    edtpRBSN.HeightPercent := 100.000000000000000000;
    edtpRBSN.MaxLength := 10;
    edtpRBSN.TabOrder := 8;
    edtpRBSN.Text := 'tpRBSN';
    edtpRBSN.WidthPercent := 100.000000000000000000;
    SetEvent(edtpRBSN, Self, 'OnKeyPress', 'edtpRBSNKeyPress');
    edtpRBSN.DataField := 'tpRBSN';
    edtpRBSN.DataSource := dtsIbsCbsClassTributariaEdit;
    edtpDoacao.SetParentComponent(Self);
    edtpDoacao.Name := 'edtpDoacao';
    edtpDoacao.Left := 357;
    edtpDoacao.Top := 549;
    edtpDoacao.Width := 99;
    edtpDoacao.Height := 21;
    edtpDoacao.ChildOrder := 31;
    edtpDoacao.HeightPercent := 100.000000000000000000;
    edtpDoacao.MaxLength := 10;
    edtpDoacao.TabOrder := 8;
    edtpDoacao.Text := 'tpDoacao';
    edtpDoacao.WidthPercent := 100.000000000000000000;
    SetEvent(edtpDoacao, Self, 'OnKeyPress', 'edtpRBSNKeyPress');
    edtpDoacao.DataField := 'tpDoacao';
    edtpDoacao.DataSource := dtsIbsCbsClassTributariaEdit;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Rt_Ibs_Cbs_CstDataset;
    DataSource.Left := 104;
    DataSource.Top := 216;
    Rt_Ibs_Cbs_CstDataset.SetParentComponent(Self);
    Rt_Ibs_Cbs_CstDataset.Name := 'Rt_Ibs_Cbs_CstDataset';
    Rt_Ibs_Cbs_CstDataset.AfterApplyUpdates := Rt_Ibs_Cbs_CstDatasetAfterApplyUpdates;
    Rt_Ibs_Cbs_CstDataset.AfterOpen := Rt_Ibs_Cbs_CstDatasetAfterOpen;
    Rt_Ibs_Cbs_CstDataset.EntitySetName := 'Rt_Ibs_Cbs_Cst';
    Rt_Ibs_Cbs_CstDataset.Connection := DMConnection.ApiConnection;
    Rt_Ibs_Cbs_CstDataset.Left := 160;
    Rt_Ibs_Cbs_CstDataset.Top := 240;
    Rt_Ibs_Cbs_CstDatasetid.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetid.Name := 'Rt_Ibs_Cbs_CstDatasetid';
    Rt_Ibs_Cbs_CstDatasetid.FieldName := 'id';
    Rt_Ibs_Cbs_CstDatasetcst.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetcst.Name := 'Rt_Ibs_Cbs_CstDatasetcst';
    Rt_Ibs_Cbs_CstDatasetcst.FieldName := 'cst';
    Rt_Ibs_Cbs_CstDatasetcst.Required := True;
    Rt_Ibs_Cbs_CstDatasetcst.Size := 255;
    Rt_Ibs_Cbs_CstDatasetdescricao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetdescricao.Name := 'Rt_Ibs_Cbs_CstDatasetdescricao';
    Rt_Ibs_Cbs_CstDatasetdescricao.FieldName := 'descricao';
    Rt_Ibs_Cbs_CstDatasetdescricao.Required := True;
    Rt_Ibs_Cbs_CstDatasetdescricao.Size := 255;
    Rt_Ibs_Cbs_CstDatasetexcluido.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetexcluido.Name := 'Rt_Ibs_Cbs_CstDatasetexcluido';
    Rt_Ibs_Cbs_CstDatasetexcluido.FieldName := 'excluido';
    Rt_Ibs_Cbs_CstDatasetinclusao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetinclusao.Name := 'Rt_Ibs_Cbs_CstDatasetinclusao';
    Rt_Ibs_Cbs_CstDatasetinclusao.FieldName := 'inclusao';
    Rt_Ibs_Cbs_CstDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Ibs_Cbs_CstDatasetalteracao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetalteracao.Name := 'Rt_Ibs_Cbs_CstDatasetalteracao';
    Rt_Ibs_Cbs_CstDatasetalteracao.FieldName := 'alteracao';
    Rt_Ibs_Cbs_CstDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Ibs_Cbs_CstDatasetexclusao.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetexclusao.Name := 'Rt_Ibs_Cbs_CstDatasetexclusao';
    Rt_Ibs_Cbs_CstDatasetexclusao.FieldName := 'exclusao';
    Rt_Ibs_Cbs_CstDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBS.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBS.Name := 'Rt_Ibs_Cbs_CstDatasetind_gIBSCBS';
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBS.FieldName := 'ind_gIBSCBS';
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBS.Size := 255;
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono.Name := 'Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono';
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono.FieldName := 'ind_gIBSCBSMono';
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono.Size := 255;
    Rt_Ibs_Cbs_CstDatasetind_gRed.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_gRed.Name := 'Rt_Ibs_Cbs_CstDatasetind_gRed';
    Rt_Ibs_Cbs_CstDatasetind_gRed.FieldName := 'ind_gRed';
    Rt_Ibs_Cbs_CstDatasetind_gRed.Size := 255;
    Rt_Ibs_Cbs_CstDatasetind_gDif.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_gDif.Name := 'Rt_Ibs_Cbs_CstDatasetind_gDif';
    Rt_Ibs_Cbs_CstDatasetind_gDif.FieldName := 'ind_gDif';
    Rt_Ibs_Cbs_CstDatasetind_gDif.Size := 255;
    Rt_Ibs_Cbs_CstDatasetind_gTransfCred.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_gTransfCred.Name := 'Rt_Ibs_Cbs_CstDatasetind_gTransfCred';
    Rt_Ibs_Cbs_CstDatasetind_gTransfCred.FieldName := 'ind_gTransfCred';
    Rt_Ibs_Cbs_CstDatasetind_gTransfCred.Size := 255;
    Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM.Name := 'Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM';
    Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM.FieldName := 'ind_gCredPresIBSZFM';
    Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet.Name := 'Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet';
    Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet.FieldName := 'ind_gAjusteCompet';
    Rt_Ibs_Cbs_CstDatasetind_RedutorBC.SetParentComponent(Rt_Ibs_Cbs_CstDataset);
    Rt_Ibs_Cbs_CstDatasetind_RedutorBC.Name := 'Rt_Ibs_Cbs_CstDatasetind_RedutorBC';
    Rt_Ibs_Cbs_CstDatasetind_RedutorBC.FieldName := 'ind_RedutorBC';
    XDataClientRt_Ibs_Cbs_CstGet.SetParentComponent(Self);
    XDataClientRt_Ibs_Cbs_CstGet.Name := 'XDataClientRt_Ibs_Cbs_CstGet';
    XDataClientRt_Ibs_Cbs_CstGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientRt_Ibs_Cbs_CstGet, Self, 'OnLoad', 'XDataClientRt_Ibs_Cbs_CstGetLoad');
    XDataClientRt_Ibs_Cbs_CstGet.Left := 40;
    XDataClientRt_Ibs_Cbs_CstGet.Top := 232;
    dtsIbsCbsClassTributaria.SetParentComponent(Self);
    dtsIbsCbsClassTributaria.Name := 'dtsIbsCbsClassTributaria';
    dtsIbsCbsClassTributaria.DataSet := cdsIbsCbsClassTributaria;
    dtsIbsCbsClassTributaria.Left := 472;
    dtsIbsCbsClassTributaria.Top := 248;
    cdsIbsCbsClassTributaria.SetParentComponent(Self);
    cdsIbsCbsClassTributaria.Name := 'cdsIbsCbsClassTributaria';
    cdsIbsCbsClassTributaria.EntitySetName := 'Rt_Ibs_Cbs_Class_Tributaria';
    cdsIbsCbsClassTributaria.Connection := DMConnection.ApiConnection;
    cdsIbsCbsClassTributaria.Left := 568;
    cdsIbsCbsClassTributaria.Top := 248;
    cdsIbsCbsClassTributariaid.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariaid.Name := 'cdsIbsCbsClassTributariaid';
    cdsIbsCbsClassTributariaid.FieldName := 'id';
    cdsIbsCbsClassTributariaid.Required := True;
    cdsIbsCbsClassTributariart_ibs_cbs_cst_id.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariart_ibs_cbs_cst_id.Name := 'cdsIbsCbsClassTributariart_ibs_cbs_cst_id';
    cdsIbsCbsClassTributariart_ibs_cbs_cst_id.FieldName := 'rt_ibs_cbs_cst_id';
    cdsIbsCbsClassTributariart_ibs_cbs_cst_id.Required := True;
    cdsIbsCbsClassTributariacclasstrib.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariacclasstrib.Name := 'cdsIbsCbsClassTributariacclasstrib';
    cdsIbsCbsClassTributariacclasstrib.FieldName := 'cclasstrib';
    cdsIbsCbsClassTributariacclasstrib.Required := True;
    cdsIbsCbsClassTributariacclasstrib.Size := 255;
    cdsIbsCbsClassTributariadata_inicio.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariadata_inicio.Name := 'cdsIbsCbsClassTributariadata_inicio';
    cdsIbsCbsClassTributariadata_inicio.FieldName := 'data_inicio';
    cdsIbsCbsClassTributariadata_inicio.DisplayFormat := 'dd/mm/yyyy';
    cdsIbsCbsClassTributariadata_fim.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariadata_fim.Name := 'cdsIbsCbsClassTributariadata_fim';
    cdsIbsCbsClassTributariadata_fim.FieldName := 'data_fim';
    cdsIbsCbsClassTributariadata_fim.DisplayFormat := 'dd/mm/yyyy';
    cdsIbsCbsClassTributariaexcluido.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariaexcluido.Name := 'cdsIbsCbsClassTributariaexcluido';
    cdsIbsCbsClassTributariaexcluido.FieldName := 'excluido';
    cdsIbsCbsClassTributariainclusao.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariainclusao.Name := 'cdsIbsCbsClassTributariainclusao';
    cdsIbsCbsClassTributariainclusao.FieldName := 'inclusao';
    cdsIbsCbsClassTributariainclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbsCbsClassTributariaalteracao.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariaalteracao.Name := 'cdsIbsCbsClassTributariaalteracao';
    cdsIbsCbsClassTributariaalteracao.FieldName := 'alteracao';
    cdsIbsCbsClassTributariaalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbsCbsClassTributariaexclusao.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributariaexclusao.Name := 'cdsIbsCbsClassTributariaexclusao';
    cdsIbsCbsClassTributariaexclusao.FieldName := 'exclusao';
    cdsIbsCbsClassTributariaexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbsCbsClassTributarianome_cClassTrib.SetParentComponent(cdsIbsCbsClassTributaria);
    cdsIbsCbsClassTributarianome_cClassTrib.Name := 'cdsIbsCbsClassTributarianome_cClassTrib';
    cdsIbsCbsClassTributarianome_cClassTrib.FieldName := 'nome_cClassTrib';
    cdsIbsCbsClassTributarianome_cClassTrib.Size := 255;
    tmrConsultaIbsCbsClassTributaria.SetParentComponent(Self);
    tmrConsultaIbsCbsClassTributaria.Name := 'tmrConsultaIbsCbsClassTributaria';
    tmrConsultaIbsCbsClassTributaria.Enabled := False;
    SetEvent(tmrConsultaIbsCbsClassTributaria, Self, 'OnTimer', 'tmrConsultaIbsCbsClassTributariaTimer');
    tmrConsultaIbsCbsClassTributaria.Left := 672;
    tmrConsultaIbsCbsClassTributaria.Top := 248;
    cdsIbsCbsClassTributariaEdit.SetParentComponent(Self);
    cdsIbsCbsClassTributariaEdit.Name := 'cdsIbsCbsClassTributariaEdit';
    cdsIbsCbsClassTributariaEdit.AfterApplyUpdates := cdsIbsCbsClassTributariaEditAfterApplyUpdates;
    cdsIbsCbsClassTributariaEdit.AfterOpen := cdsIbsCbsClassTributariaEditAfterOpen;
    cdsIbsCbsClassTributariaEdit.EntitySetName := 'Rt_Ibs_Cbs_Class_Tributaria';
    cdsIbsCbsClassTributariaEdit.Connection := DMConnection.ApiConnection;
    cdsIbsCbsClassTributariaEdit.Left := 336;
    cdsIbsCbsClassTributariaEdit.Top := 576;
    IntegerField1.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'id';
    IntegerField2.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    IntegerField2.Name := 'IntegerField2';
    IntegerField2.FieldName := 'rt_ibs_cbs_cst_id';
    StringField1.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'cclasstrib';
    StringField1.Size := 255;
    StringField2.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'descricao';
    StringField2.Size := 255;
    StringField3.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'lei_complementar';
    StringField3.Size := 255;
    StringField4.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    StringField4.Name := 'StringField4';
    StringField4.FieldName := 'lei_complementar_redacao';
    StringField4.Size := 255;
    DateTimeField1.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    DateTimeField1.Name := 'DateTimeField1';
    DateTimeField1.FieldName := 'data_inicio';
    DateTimeField1.DisplayFormat := 'yyyy-MM-dd';
    DateTimeField2.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    DateTimeField2.Name := 'DateTimeField2';
    DateTimeField2.FieldName := 'data_fim';
    DateTimeField2.DisplayFormat := 'yyyy-MM-dd';
    BooleanField1.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    BooleanField1.Name := 'BooleanField1';
    BooleanField1.FieldName := 'excluido';
    DateTimeField3.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    DateTimeField3.Name := 'DateTimeField3';
    DateTimeField3.FieldName := 'inclusao';
    DateTimeField3.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    DateTimeField4.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    DateTimeField4.Name := 'DateTimeField4';
    DateTimeField4.FieldName := 'alteracao';
    DateTimeField4.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    DateTimeField5.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    DateTimeField5.Name := 'DateTimeField5';
    DateTimeField5.FieldName := 'exclusao';
    DateTimeField5.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIbsCbsClassTributariaEditnome_cClassTrib.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditnome_cClassTrib.Name := 'cdsIbsCbsClassTributariaEditnome_cClassTrib';
    cdsIbsCbsClassTributariaEditnome_cClassTrib.FieldName := 'nome_cClassTrib';
    cdsIbsCbsClassTributariaEditnome_cClassTrib.Size := 255;
    cdsIbsCbsClassTributariaEdittipo_aliquota.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEdittipo_aliquota.Name := 'cdsIbsCbsClassTributariaEdittipo_aliquota';
    cdsIbsCbsClassTributariaEdittipo_aliquota.FieldName := 'tipo_aliquota';
    cdsIbsCbsClassTributariaEdittipo_aliquota.Size := 255;
    cdsIbsCbsClassTributariaEditpRedIBS.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditpRedIBS.Name := 'cdsIbsCbsClassTributariaEditpRedIBS';
    cdsIbsCbsClassTributariaEditpRedIBS.FieldName := 'pRedIBS';
    cdsIbsCbsClassTributariaEditpRedIBS.Size := 255;
    cdsIbsCbsClassTributariaEditpRedCBS.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditpRedCBS.Name := 'cdsIbsCbsClassTributariaEditpRedCBS';
    cdsIbsCbsClassTributariaEditpRedCBS.FieldName := 'pRedCBS';
    cdsIbsCbsClassTributariaEditpRedCBS.Size := 255;
    cdsIbsCbsClassTributariaEditind_gTribRegular.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditind_gTribRegular.Name := 'cdsIbsCbsClassTributariaEditind_gTribRegular';
    cdsIbsCbsClassTributariaEditind_gTribRegular.FieldName := 'ind_gTribRegular';
    cdsIbsCbsClassTributariaEditind_gTribRegular.Size := 255;
    cdsIbsCbsClassTributariaEditdata_atualizacao.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditdata_atualizacao.Name := 'cdsIbsCbsClassTributariaEditdata_atualizacao';
    cdsIbsCbsClassTributariaEditdata_atualizacao.FieldName := 'data_atualizacao';
    cdsIbsCbsClassTributariaEditindNFe.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditindNFe.Name := 'cdsIbsCbsClassTributariaEditindNFe';
    cdsIbsCbsClassTributariaEditindNFe.FieldName := 'indNFe';
    cdsIbsCbsClassTributariaEditindNFCe.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditindNFCe.Name := 'cdsIbsCbsClassTributariaEditindNFCe';
    cdsIbsCbsClassTributariaEditindNFCe.FieldName := 'indNFCe';
    cdsIbsCbsClassTributariaEditindNFSe.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditindNFSe.Name := 'cdsIbsCbsClassTributariaEditindNFSe';
    cdsIbsCbsClassTributariaEditindNFSe.FieldName := 'indNFSe';
    cdsIbsCbsClassTributariaEditind_gEstornoCred.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditind_gEstornoCred.Name := 'cdsIbsCbsClassTributariaEditind_gEstornoCred';
    cdsIbsCbsClassTributariaEditind_gEstornoCred.FieldName := 'ind_gEstornoCred';
    cdsIbsCbsClassTributariaEditind_gCredPresOper.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditind_gCredPresOper.Name := 'cdsIbsCbsClassTributariaEditind_gCredPresOper';
    cdsIbsCbsClassTributariaEditind_gCredPresOper.FieldName := 'ind_gCredPresOper';
    cdsIbsCbsClassTributariaEditind_gMonoPadrao.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditind_gMonoPadrao.Name := 'cdsIbsCbsClassTributariaEditind_gMonoPadrao';
    cdsIbsCbsClassTributariaEditind_gMonoPadrao.FieldName := 'ind_gMonoPadrao';
    cdsIbsCbsClassTributariaEditind_gMonoReten.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditind_gMonoReten.Name := 'cdsIbsCbsClassTributariaEditind_gMonoReten';
    cdsIbsCbsClassTributariaEditind_gMonoReten.FieldName := 'ind_gMonoReten';
    cdsIbsCbsClassTributariaEditind_gMonoRet.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditind_gMonoRet.Name := 'cdsIbsCbsClassTributariaEditind_gMonoRet';
    cdsIbsCbsClassTributariaEditind_gMonoRet.FieldName := 'ind_gMonoRet';
    cdsIbsCbsClassTributariaEditind_gpBioDiferenca.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEditind_gpBioDiferenca.Name := 'cdsIbsCbsClassTributariaEditind_gpBioDiferenca';
    cdsIbsCbsClassTributariaEditind_gpBioDiferenca.FieldName := 'ind_gpBioDiferenca';
    cdsIbsCbsClassTributariaEdittpRBSN.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEdittpRBSN.Name := 'cdsIbsCbsClassTributariaEdittpRBSN';
    cdsIbsCbsClassTributariaEdittpRBSN.FieldName := 'tpRBSN';
    cdsIbsCbsClassTributariaEdittpDoacao.SetParentComponent(cdsIbsCbsClassTributariaEdit);
    cdsIbsCbsClassTributariaEdittpDoacao.Name := 'cdsIbsCbsClassTributariaEdittpDoacao';
    cdsIbsCbsClassTributariaEdittpDoacao.FieldName := 'tpDoacao';
    dtsIbsCbsClassTributariaEdit.SetParentComponent(Self);
    dtsIbsCbsClassTributariaEdit.Name := 'dtsIbsCbsClassTributariaEdit';
    dtsIbsCbsClassTributariaEdit.DataSet := cdsIbsCbsClassTributariaEdit;
    dtsIbsCbsClassTributariaEdit.Left := 168;
    dtsIbsCbsClassTributariaEdit.Top := 568;
    cdsIbsCbsCst.SetParentComponent(Self);
    cdsIbsCbsCst.Name := 'cdsIbsCbsCst';
    cdsIbsCbsCst.AfterOpen := cdsIbsCbsCstAfterOpen;
    cdsIbsCbsCst.EntitySetName := 'Rt_Ibs_Cbs_Cst';
    cdsIbsCbsCst.Connection := DMConnection.ApiConnection;
    cdsIbsCbsCst.QueryTop := 100;
    cdsIbsCbsCst.Left := 72;
    cdsIbsCbsCst.Top := 560;
    cdsIbsCbsCstid.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstid.Name := 'cdsIbsCbsCstid';
    cdsIbsCbsCstid.FieldName := 'id';
    cdsIbsCbsCstid.Required := True;
    cdsIbsCbsCstdescricao.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstdescricao.Name := 'cdsIbsCbsCstdescricao';
    cdsIbsCbsCstdescricao.FieldName := 'descricao';
    cdsIbsCbsCstdescricao.Required := True;
    cdsIbsCbsCstdescricao.Size := 255;
    cdsIbsCbsCstcst.SetParentComponent(cdsIbsCbsCst);
    cdsIbsCbsCstcst.Name := 'cdsIbsCbsCstcst';
    cdsIbsCbsCstcst.FieldName := 'cst';
    cdsIbsCbsCstcst.Required := True;
    cdsIbsCbsCstcst.Size := 255;
  finally
    lbid.AfterLoadDFMValues;
    lbcst.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbTotalIbsCbsClassTributaria.AfterLoadDFMValues;
    lbid_classtrib.AfterLoadDFMValues;
    lbrt_ibs_cbs_cst_id.AfterLoadDFMValues;
    lbcclasstrib.AfterLoadDFMValues;
    lbdescricao_classtrib.AfterLoadDFMValues;
    lblei_complementar.AfterLoadDFMValues;
    lblei_complementar_redacao.AfterLoadDFMValues;
    lbdata_inicio.AfterLoadDFMValues;
    lbdata_fim.AfterLoadDFMValues;
    lbexcluido_classtrib.AfterLoadDFMValues;
    lbinclusao_classtrib.AfterLoadDFMValues;
    lbalteracao_classtrib.AfterLoadDFMValues;
    lbexclusao_classtrib.AfterLoadDFMValues;
    lbind_gIBSCBS.AfterLoadDFMValues;
    lbind_gIBSCBSMono.AfterLoadDFMValues;
    lbind_gRed.AfterLoadDFMValues;
    lbind_gDif.AfterLoadDFMValues;
    lbind_gTransfCred.AfterLoadDFMValues;
    lbind_gCredPresIBSZFM.AfterLoadDFMValues;
    lbind_gAjusteCompet.AfterLoadDFMValues;
    lbnome_cClassTrib.AfterLoadDFMValues;
    lbpRedCBS.AfterLoadDFMValues;
    lbind_gTribRegular.AfterLoadDFMValues;
    lbtipo_aliquota.AfterLoadDFMValues;
    lbpRedIBS.AfterLoadDFMValues;
    lbdata_atualizacao.AfterLoadDFMValues;
    lbindNFe.AfterLoadDFMValues;
    lbindNFCe.AfterLoadDFMValues;
    lbindNFSe.AfterLoadDFMValues;
    lbind_gEstornoCred.AfterLoadDFMValues;
    lbind_gCredPresOper.AfterLoadDFMValues;
    lbind_gMonoPadrao.AfterLoadDFMValues;
    lbind_gMonoReten.AfterLoadDFMValues;
    lbind_gMonoRet.AfterLoadDFMValues;
    lbind_gpBioDiferenca.AfterLoadDFMValues;
    lbtpRBSN.AfterLoadDFMValues;
    lbtpDoacao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edcst.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    pnlEspacoFormRt_Ibs_Cbs_Cst.AfterLoadDFMValues;
    btnRt_Ibs_Cbs_Cst.AfterLoadDFMValues;
    btnIbsCbsClassTributaria.AfterLoadDFMValues;
    pnlIbsCbsClassTributaria.AfterLoadDFMValues;
    cbPageSizeIbsCbsClassTributaria.AfterLoadDFMValues;
    IbsCbsClassTributariaSearch.AfterLoadDFMValues;
    tblIbsCbsClassTributaria.AfterLoadDFMValues;
    wlcIbsCbsClassTributaria.AfterLoadDFMValues;
    pnlEspacoFormIbsCbsClassTributaria.AfterLoadDFMValues;
    edid_classtrib.AfterLoadDFMValues;
    edcclasstrib.AfterLoadDFMValues;
    eddescricao_classtrib.AfterLoadDFMValues;
    edlei_complementar.AfterLoadDFMValues;
    edlei_complementar_redacao.AfterLoadDFMValues;
    edinclusao_classtrib.AfterLoadDFMValues;
    edalteracao_classtrib.AfterLoadDFMValues;
    ed_exclusao.AfterLoadDFMValues;
    cbExcluidoClassTrib.AfterLoadDFMValues;
    cbbIbsCbsCstId.AfterLoadDFMValues;
    btnNovo.AfterLoadDFMValues;
    eddata_inicio.AfterLoadDFMValues;
    eddata_fim.AfterLoadDFMValues;
    btnSalvarClassTrib.AfterLoadDFMValues;
    edind_gIBSCBS.AfterLoadDFMValues;
    edind_gIBSCBSMono.AfterLoadDFMValues;
    edind_gRed.AfterLoadDFMValues;
    edind_gDif.AfterLoadDFMValues;
    edind_gTransfCred.AfterLoadDFMValues;
    cbind_gCredPresIBSZFM.AfterLoadDFMValues;
    cbind_gAjusteCompet.AfterLoadDFMValues;
    ednome_cClassTrib.AfterLoadDFMValues;
    edpRedCBS.AfterLoadDFMValues;
    edind_gTribRegular.AfterLoadDFMValues;
    edtipo_aliquota.AfterLoadDFMValues;
    edpRedIBS.AfterLoadDFMValues;
    eddata_atualizacao.AfterLoadDFMValues;
    cbindNFe.AfterLoadDFMValues;
    cbindNFCe.AfterLoadDFMValues;
    cbindNFSe.AfterLoadDFMValues;
    cbind_gEstornoCred.AfterLoadDFMValues;
    cbind_gCredPresOper.AfterLoadDFMValues;
    cbind_gMonoPadrao.AfterLoadDFMValues;
    cbind_gMonoReten.AfterLoadDFMValues;
    cbind_gMonoRet.AfterLoadDFMValues;
    cbind_gpBioDiferenca.AfterLoadDFMValues;
    cbind_RedutorBC.AfterLoadDFMValues;
    edtpRBSN.AfterLoadDFMValues;
    edtpDoacao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDataset.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetid.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetcst.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetdescricao.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetexcluido.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetinclusao.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetalteracao.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetexclusao.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBS.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_gIBSCBSMono.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_gRed.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_gDif.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_gTransfCred.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_gCredPresIBSZFM.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_gAjusteCompet.AfterLoadDFMValues;
    Rt_Ibs_Cbs_CstDatasetind_RedutorBC.AfterLoadDFMValues;
    XDataClientRt_Ibs_Cbs_CstGet.AfterLoadDFMValues;
    dtsIbsCbsClassTributaria.AfterLoadDFMValues;
    cdsIbsCbsClassTributaria.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaid.AfterLoadDFMValues;
    cdsIbsCbsClassTributariart_ibs_cbs_cst_id.AfterLoadDFMValues;
    cdsIbsCbsClassTributariacclasstrib.AfterLoadDFMValues;
    cdsIbsCbsClassTributariadata_inicio.AfterLoadDFMValues;
    cdsIbsCbsClassTributariadata_fim.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaexcluido.AfterLoadDFMValues;
    cdsIbsCbsClassTributariainclusao.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaalteracao.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaexclusao.AfterLoadDFMValues;
    cdsIbsCbsClassTributarianome_cClassTrib.AfterLoadDFMValues;
    tmrConsultaIbsCbsClassTributaria.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEdit.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    IntegerField2.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    StringField4.AfterLoadDFMValues;
    DateTimeField1.AfterLoadDFMValues;
    DateTimeField2.AfterLoadDFMValues;
    BooleanField1.AfterLoadDFMValues;
    DateTimeField3.AfterLoadDFMValues;
    DateTimeField4.AfterLoadDFMValues;
    DateTimeField5.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditnome_cClassTrib.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEdittipo_aliquota.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditpRedIBS.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditpRedCBS.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditind_gTribRegular.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditdata_atualizacao.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditindNFe.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditindNFCe.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditindNFSe.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditind_gEstornoCred.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditind_gCredPresOper.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditind_gMonoPadrao.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditind_gMonoReten.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditind_gMonoRet.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEditind_gpBioDiferenca.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEdittpRBSN.AfterLoadDFMValues;
    cdsIbsCbsClassTributariaEdittpDoacao.AfterLoadDFMValues;
    dtsIbsCbsClassTributariaEdit.AfterLoadDFMValues;
    cdsIbsCbsCst.AfterLoadDFMValues;
    cdsIbsCbsCstid.AfterLoadDFMValues;
    cdsIbsCbsCstdescricao.AfterLoadDFMValues;
    cdsIbsCbsCstcst.AfterLoadDFMValues;
  end;
end;

end.
